import { useState, useEffect, useContext, ChangeEvent } from 'react';
import { Formik, Form, Field, ErrorMessage, FormikErrors } from 'formik';
import {
    Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField, IconButton,
    FormHelperText, Grid, LinearProgress, Tooltip, FormControlLabel, Checkbox, Alert, SelectChangeEvent, styled, Switch
} from '@mui/material';
import { Modal as ModalStrap, ModalHeader, ModalBody, TabContent, TabPane, Nav, NavItem, NavLink, List } from 'reactstrap';
import * as Yup from 'yup';
import { TipoProductoDTO } from '../../interfaces/TipoProductoDTO';
import CatalogService, { RolColaboradorProducto } from '../../services/CatalogService';
import ProductoService from '../../services/ProductoService';
import AlertService from '../../services/AlertService';
import { useNavigate, useParams } from 'react-router-dom';
import { RiSave3Fill } from 'react-icons/ri';
import { MdAssignmentReturn } from 'react-icons/md';
import { BiAddToQueue } from 'react-icons/bi';
import { AiFillCaretLeft } from 'react-icons/ai';
import Stack from '@mui/material/Stack';
import { AiOutlineUserAdd, AiFillDelete, AiOutlinePlusCircle, AiOutlineSearch } from 'react-icons/ai';
import { FaRegAddressCard, FaPlusCircle, FaFilePdf } from 'react-icons/fa';
import { BsEraserFill, BsInfoSquare } from 'react-icons/bs';
import { format, parse } from 'date-fns';
import { ObjetoLabel, ObjetoLabelFilter } from '../../interfaces/ObjetoLabel';
import { IndexacionDTO } from '../../interfaces/IndexacionDTO';
import { ProductoTerminadoDTO, getVoidProdcutoTerminadoDTO } from '../../interfaces/ProductoTerminadoDTO';
import { CasUserContext, useCasUserContext } from '../../services/casUserContext';
import { TblProductoProdTermin, setProductoTerminado } from '../../interfaces/TblProductoProdTermin';
import { TblDecInvMotivoProdTermin, setProductoMotivo } from '../../interfaces/TblDecInvMotivoProdTermin';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { ProductoColaboradorDTO, setListProductoColaborador } from '../../interfaces/ColaboradorProdcutoDTO';
import { CatagNumberDTO, CatalogoToReactSelect } from '../../interfaces/CatalogoDTO';
import { Unidad } from '../../interfaces/Unidad';
import { Card as CardUI, CardActions, CardContent } from '@mui/material';
import Typography from '@mui/material/Typography';
import ProyectoService from '../../services/ProyectoService';
import { ProyectoColaboradoreDTO } from '../../interfaces/ProyectoColaboradoreDTO';
import { FileModel, setFileModelWithName } from '../../interfaces/FileModel';
import { ProductoTerminadoObjOdDTO, setProductoTerminadoObjOdDTO } from '../../interfaces/ProductoTerminadoObjOdDTO';
import { ODS } from '../../interfaces/ODS';
//tener cuidado con la importacion
import '../../services/utils';
import { ProductoAreaConocimientoDTO, getVoidProductoAreaConocimientoDTO, setProductoAreaConocimientoDTO } from '../../interfaces/ProductoAreaConocimientoDTO';
import { ProductoLineaInvestigacionDTO, setProductoLineaInvestigacionDTO } from '../../interfaces/ProductoLineaInvestigacionDTO';
import { convertirFormatoFecha } from '../../services/utils';
import { ProyectoRelacionado, setListProyectoRelacionado } from '../../interfaces/ProyectoRelacionado';
import { ProyectoAreaConocimientoDTO } from '../../interfaces/ProyectoAreaConocimientoDTO';
import { ProductoTerminSolicitanteDTO, setListProductoTerminSolicitante } from '../../interfaces/ProductoTerminSolicitanteDTO';
import { CategoriaProductoDTO } from '../../interfaces/CategoriaProductoDTO';
import { ProductoObjEspecifico, getVoidProductoEspecifico, setListProductoEspecifico } from '../../interfaces/ProductoObjEspecificoDTO';
import { getVoidProductoInstitucionPais, setProductoInstitucionPais } from '../../interfaces/ProductoInstitucionPaisDTO';
import PostGradoService from '../../services/PostGradoService';
import { setProductoPostGrado } from '../../interfaces/ProductoPostGradoDTO';
import { GetVoidProductoResultado, ProductoResultado, setListProductoResultado } from '../../interfaces/ProductoResultadoDTO';
import { GetVoidProductoFactorImpacto, ProductoFactorImpacto, SetListProductoFactorImpacto } from '../../interfaces/ProductoFactorImpacto';
import { ProductoAreaImplementacion, setAreaImplementacion } from '../../interfaces/ProductoAreaImplementacionDTO';
import { ProductoArchivo, getVoidProductoArchivo, setListProductoArchivo } from '../../interfaces/ProductoArchivo';
import BotonArchivoAdjunto from './BottonAdjuntos';
import { EmailProductoCreado, setEmailProductoCreado } from '../../interfaces/MailModel';
import EmailService from '../../services/EmailService';
import { formatDate } from '../../interfaces/Utils/FechaFormater';
import { GuardarFormSchema, ProductoFormSchema } from '../ValidationForm/validationFormProductos';
import { Option } from '../../interfaces/ProyectosDTOS/Option'
import { CastListDoctoradosVigenciaDTOtoListOption } from '../../interfaces/PostGrado/DoctoradoVigenteDTO';
import { CastListProgramaPostGradotoListOption } from '../../interfaces/PostGrado/ResponsePost';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const COLOR_RESALTAR = '#FFFF99';

const catalogService = new CatalogService();
const productoService = new ProductoService();
const proyectoService = new ProyectoService();
const alertaService = new AlertService();
const postGradoService = new PostGradoService();
const emailService = new EmailService();

const styleModal = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60vw',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const cardHeaderStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
};

const tabStyle = {
    cursor: 'pointer', // Cambia el cursor a "pointer" cuando se pasa sobre el botón
};

const buttonStyle = {
    marginTop: '10px', // Ajusta el valor de acuerdo a tu preferencia
};

interface Props {
    productoterminado: ProductoTerminadoDTO,
    defaultTipo: number,
    defaultCategoria?: number,
    usoProyectosParticipo?: boolean,
    idProducto: string,
    categoriasAvalible: Array<number>,
    tiposAvalible: Array<number>,
    importScopus?: boolean;
    onResponse?: (dataRespuesta: ProductoTerminadoDTO) => void // Función para pasar la respuesta al padre
}

export default function ProductoForm(parametro: Props) {
    let history = useNavigate()
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const token = casUserContext.token;
    const idusuariocrea = casUserContext.userData.idpersona;
    const cedulaCreador = casUserContext.userData.numeroidentificacion;
    const user = casUserContext.userData;
    const idpersona = casUserContext.userData.idpersona;
    const nombresUsuario = casUserContext.userData.nombres;
    const apellidosUsuario = casUserContext.userData.apellidos;
    const emailAddress = casUserContext.userData.emailAddress;
    const [ready, setReady] = useState(false);
    const [datosFormulario, setDatosFormulario] = useState<ProductoTerminadoDTO>(parametro.productoterminado);
    const [responseData, setResponseData] = useState<ProductoTerminadoDTO>();
    const [modo, setModo] = useState<string>('C');
    //#region Seccion Variables
    const anioActual: number = new Date().getFullYear();
    const [tipoProductos, setTipoProductos] = useState<Array<TipoProductoDTO>>([])
    const [anios, setAnios] = useState<Array<number>>([])
    const [desicion, setDesicion] = useState<Array<ObjetoLabel>>([])
    const [desicionNum, setDesicionNum] = useState<Array<ObjetoLabelFilter>>([])
    const [tieneproy, setTieneproy] = useState<Array<ObjetoLabel>>([])
    const [unidades, setUnidades] = useState<Array<Unidad>>([])
    const [misProyectos, setMisProyectos] = useState<Array<CatagNumberDTO>>([])
    const [quartil, setQuartil] = useState<Array<ObjetoLabel>>([])
    const [motivos, setMotivos] = useState<Array<ObjetoLabel>>([])
    const [listIndex, setListIndex] = useState<Array<IndexacionDTO>>([])
    const [listRolColaborador, setListRolColaborador] = useState<Array<ObjetoLabelFilter>>(RolColaboradorProducto)
    const [estadoEquipo, setEstadoEquipo] = useState<Array<ObjetoLabelFilter>>([])
    const [frecuencia, setFrecuencia] = useState<Array<ObjetoLabelFilter>>([])
    const [tipoColaborador, setTipoColaborador] = useState<Array<ObjetoLabelFilter>>([])
    let [categorias, setCategorias] = useState<Array<CategoriaProductoDTO>>([])
    let [colaboradorProyecto, setColaboradorProyecto] = useState<Array<ProyectoColaboradoreDTO>>([])
    let [busquedaUsuario, setBusquedaUsuario] = useState<Array<ProyectoColaboradoreDTO>>([])
    let [open, setOpen] = useState(false);
    let [userModal, setUserModal] = useState(false);
    let [proyModal, setProyModal] = useState(false);
    let [loadingModal, setLoadingModal] = useState(false);
    let [listODS, setListODS] = useState<Array<CatagNumberDTO>>([]);
    let [areasLineasInvestigacion, setAreasLineasInvestigacion] = useState<Array<CatagNumberDTO>>([]);
    let [areasCine, setAreasCine] = useState<Array<CatagNumberDTO>>([]);
    let [loadedAreasCine, setLoadedAreasCine] = useState(false);
    let [subAreasCine, setSubAreasCine] = useState<Array<CatagNumberDTO>>([]);
    let [loadedSubAreasCine, setLoadedSubAreasCine] = useState(false);
    let [subAreasCineDet, setSubAreasCineDet] = useState<Array<CatagNumberDTO>>([]);
    let [loadedSubAreasCineDet, setLoadedSubAreasCineDet] = useState(false);
    let [tap, setTap] = useState(0);
    let [mailBusqueda, setMailBusqueda] = useState('');
    let [apellidosBusqueda, setApellidosBusqueda] = useState('');
    let [listRol, setListRol] = useState<Array<ObjetoLabelFilter>>(RolColaboradorProducto);
    let [tipopatente, setTipoPatente] = useState<Array<CatagNumberDTO>>([]);
    let [paises, setPaises] = useState<Array<CatagNumberDTO>>([]);
    let [areasProyecto, setAreasProyecto] = useState<Array<ProyectoAreaConocimientoDTO>>([]);
    let [listProgramas, setListProgramas] = useState<Array<Option>>([]);
    let [listProgramasPostgrado, setListProgramasPostgrado] = useState<Array<Option>>([]);
    let [listProgramasDoctorado, setListProgramasDoctorado] = useState<Array<Option>>([]);
    let [progress, setProgress] = useState(0);
    //#endregion  
    //#region Seccion Funciones
    const fetchData = async () => {
        //console.log(parametro.productoterminado);
        let idusuario = casUserContext.userData.idpersona;
        if (parametro.productoterminado.producto.iddecinvproyectoprodtermin > 0) {
            idusuario = parametro.productoterminado.motivo.idpersona;
        }
        try {
            alertaService.showLoading("Cargando Datos");
            setAnios(catalogService.generateYearList(2015, anioActual))
            setDesicion(catalogService.getDecision)
            setDesicionNum(catalogService.getDecisionNum)
            setTieneproy(catalogService.getDecision)
            setQuartil(catalogService.getCuartil)
            setMotivos(catalogService.getMotivoProducto)
            setListRolColaborador(RolColaboradorProducto)
            setTipoColaborador(catalogService.getTipoColaborador);
            setEstadoEquipo(catalogService.getEstadoEquipo);
            setFrecuencia(catalogService.getFrecuencia);
            setProductoTermin(parametro.productoterminado);
            catalogService.obtenerGetObjODS()
                .then((data) => {
                    //console.log(data.objDatos);
                    setListODS(data.listData);
                })
                .catch((error) => console.error(error));
            catalogService.obtenerGetAreasConocimiento()
                .then((data) => {
                    if (data.status.isSuccessfully) {
                        setAreasCine(data.listData);
                        setLoadedAreasCine(true);
                    }
                })
                .catch((error) => console.error(error))
            catalogService.obtenerGetAreasLineasInvestigacion()
                .then((data) => {
                    //console.log(data.objDatos);
                    if (data.status.isSuccessfully) {
                        setAreasLineasInvestigacion(data.listData);
                    }
                })
                .catch((error) => console.error(error));
            manjeoTipoPatente(datosFormulario.producto.iddecinvtipoproductoesperado);
            catalogService.obtenerGetCatalogoPaises()
                .then((data) => {
                    //console.log(data)
                    if (data.status.isSuccessfully) {
                        setPaises(data.listData)
                    }
                })
                .catch((error) => console.error(error));
            postGradoService.ConsultaProgramasAcademicosVigentes(token)
                .then((data) => {
                    if (data.status.isSuccessfully) {
                        setListProgramasPostgrado(CastListProgramaPostGradotoListOption(data.listData))
                    } else {
                        setListProgramasPostgrado([])
                    }
                })
                .catch((error) => console.error(error))
            postGradoService.GetDoctoradosVigencia(token)
                .then((data) => {
                    if (data.status.isSuccessfully) {
                        setListProgramasDoctorado(CastListDoctoradosVigenciaDTOtoListOption(data.listData.filter(x => x.esVigente === 'S')))
                    } else {
                        setListProgramasDoctorado([])
                    }
                })
                .catch((error) => console.error(error))
            manjeoProgramasPostgrado(datosFormulario.producto.iddecinvtipoproductoesperado);
            await catalogService.obtenerCatalogoTipoProducto()
                .then((data) => {
                    setTipoProductos(data.listData)
                    //console.log(data.objDatos)
                })
                .catch((error) => console.error(error))
            await catalogService.obtenerCatalogoCategoriaProducto()
                .then((data) => {
                    setCategorias(data.listData)
                    //console.log(data.objDatos)
                })
                .catch((error) => console.error(error))
            await catalogService.obtenerCatalogoUnidades()
                .then((data) => setUnidades(data.objDatos))
                .catch((error) => console.error(error))
            await catalogService.obtenerGetIndexCatalog()
                .then((data) => setListIndex(data.listData))
                .catch((error) => console.error(error))
            if (parametro.usoProyectosParticipo) {
                await catalogService.obtenerGetMisProyectosAprobadosParticipo(idusuario, token)
                    .then((data) => {
                        //console.log(data);
                        if (data.status.isSuccessfully) {
                            setMisProyectos(data.listData);
                        }
                    })
                    .catch((error) => console.error(error));
            } else {
                await catalogService.obtenerGetMisProyectosAprobados(idusuario, token)
                    .then((data) => {
                        //console.log(data);
                        if (data.status.isSuccessfully) {
                            setMisProyectos(data.listData);
                        }
                    })
                    .catch((error) => console.error(error));
            }
            setProgress(100);
            setInterval(() => {
                setReady(true);
            }, 500);
            alertaService.hideLoading();
        } catch (error) {
            console.error('Error:', error);
            alertaService.hideLoading();
            alertaService.alertaAdvertencia('Alerta', 'Ocurrio un error al momento de cargar la información.');
            setReady(true);
        }
    };
    const simulateLoading = () => {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                setProgress((prevProgress) => {
                    const newProgress = prevProgress + 10; // Incremento de progreso
                    if (newProgress >= 90) {
                        clearInterval(interval);
                    }
                    return newProgress;
                });
            }, 1000); // Intervalo de simulación
        });
    };
    const handleTap = (event: React.SyntheticEvent, newValue: number) => {
        setTap(newValue);
    };
    function manjeoTipoPatente(id: number) {
        let cod = 0;
        switch (id) {
            case 33:
                cod = 3812;
                break;
            case 45:
                cod = 3820;
                break;
            case 47:
                cod = 3829;
                break;
            default:
                cod = 3808;
                break;
        }
        catalogService.obtenerGetCatalogoById(cod)
            .then((data) => {
                if (data.status.isSuccessfully) {
                    //console.log(data)
                    setTipoPatente(data.listData)
                }
            })
            .catch((error) => console.error(error));
    }
    function manjeoProgramasPostgrado(id: number) {
        switch (id) {
            case 29://TESIS DE MAESTRIA DE INVESTIGACIÓN
                setListProgramas(listProgramasPostgrado);
                break;
            case 30://TESIS DE DOCTORADO
                setListProgramas(listProgramasPostgrado);
                break;
            case 42://PROYECTO DE TITULACIÓN DE MAESTRIA PROFESIONAL
                setListProgramas(listProgramasPostgrado);
                break;
            case 48://INFORME DE AVANCE DE DOCTORADO
                setListProgramas(listProgramasDoctorado);
                break;
            default:
                setListProgramas([]);
        }
    }
    function CustomTabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }
    function listRolAjust(id: number) {
        //INV -> Inventores
        //El set no responde bien al momento de editar
        //setListRol(catalogService.getRolColaboradorProducto)
        //console.log(listRol);
        switch (id) {
            case 28:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'LCL')));
                break;
            case 29:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'T')));
                break;
            case 30:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'T')));
                break;
            case 32:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'INV')));
                break;
            case 34:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'INV')));
                break;
            case 35:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'C')));
                break;
            case 37:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'U')));
                break;
            case 39:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'A' || x.visibilidad === 'I')));
                break;
            case 41:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'E' || x.visibilidad === 'T')));
                break;
            case 42:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'T')));
                break;
            case 48:
                setListRolColaborador(listRol.filter(x => (x.visibilidad === 'S' || x.visibilidad === 'T')));
                break;
            default:
                setListRolColaborador(listRol.filter(x => x.visibilidad === 'S'));
                break;
        }
    }
    const handleOpenModal = () => setOpen(true);
    const handleCloseModal = () => setOpen(false);
    const toggleOpen = () => {
        setOpen(!open);
    };
    const handleProyOpen = () => setProyModal(true);
    const handleProyClose = () => setProyModal(false);
    const toggleProy = () => {
        setProyModal(!proyModal);
    };
    const handleOpenUserModal = () => setUserModal(true);
    const handleCloseUserModal = () => setUserModal(false);
    const toggleModal = () => {
        setUserModal(!userModal);
    };
    const goToNavigation = (site: string) => {
        history(site)
    }
    function setListColaboradores(idproyecto: number) {
        proyectoService.GetColaboradoresProyectoById(idproyecto, token)
            .then(async (data) => {
                //console.log(data.objDatos);
                setColaboradorProyecto(data.listData);
            })
            .catch((error) => console.error(error));
    }
    function setListBusqueda(apellidos: string, email: string) {
        setLoadingModal(true);
        proyectoService.GetDatosPersonalesColaborador(apellidos, email, token)
            .then((data) => {
                //console.log(data.objDatos);
                if (data.listData === null) {
                    setBusquedaUsuario([]);
                    setLoadingModal(false);
                } else {
                    setBusquedaUsuario(data.listData);
                    setLoadingModal(false);
                }
            })
            .catch((error) => {
                console.error(error)
                setBusquedaUsuario([]);
                setLoadingModal(false);
            });
    }
    const handleEmailBusquedaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        //console.log(value);
        setMailBusqueda(value);
    }
    const handleEmailBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        // Acciones a realizar cuando el campo de entrada pierde el foco
        //console.log('Campo perdió el foco. Valor actual:', mailBusqueda);
    };
    const handleApellidosBusquedaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Actualizar el estado
        if (value !== apellidosBusqueda) {
            setApellidosBusqueda(value);
        }
    }
    function ArchivoHandler(num: number, archivos: Array<ProductoArchivo>): ProductoArchivo {
        let archivo = archivos.find(x => x.numero === num) ?? getVoidProductoArchivo();
        return archivo;
    }
    function linkDspace(ideref: string): string {
        if (ideref === '' || ideref === null) {
            return '';
        }
        let listaArray: string[] = ideref.split(",");
        let enlace = 'http://192.168.1.125/rest/bitstreams/{ideref}/retrieve';
        enlace = enlace.replace("{ideref}", listaArray[1]);
        return enlace;
    }
    function OpenArchivo(archivo: ProductoArchivo) {
        if (archivo.iddecinvproductoarchivo > 0) {
            window.open(linkDspace(archivo.refarchivo), '_blank');
        }
    }
    function setProductoTermin(data: ProductoTerminadoDTO) {
        if (parametro.idProducto === '0' && parametro.defaultTipo !== 0) {
            data.producto.iddecinvtipoproductoesperado = parametro.defaultTipo
        }
        //console.log(data);
        setDatosFormulario({
            ...datosFormulario,
            producto: setProductoTerminado(data.producto) as TblProductoProdTermin,
            motivo: setProductoMotivo(data.motivo) as TblDecInvMotivoProdTermin,
            areaConocimiento: setProductoAreaConocimientoDTO(data.areaConocimiento) as ProductoAreaConocimientoDTO,
            areaImplementacion: setAreaImplementacion(data.areaImplementacion) as ProductoAreaImplementacion,
            lineaInvestigacion: setProductoLineaInvestigacionDTO(data.lineaInvestigacion) as ProductoLineaInvestigacionDTO,
            ods: setProductoTerminadoObjOdDTO(data.ods) as ProductoTerminadoObjOdDTO,
            colProducto: setListProductoColaborador(data.colProducto) as Array<ProductoColaboradorDTO>,
            solicitantes: setListProductoTerminSolicitante(data.solicitantes) as Array<ProductoTerminSolicitanteDTO>,
            institucion: setProductoInstitucionPais(data.institucion),
            archivosProd: setListProductoArchivo(data.archivosProd),
            proyectorel: setListProyectoRelacionado(data.proyectorel),
            postgrados: setProductoPostGrado(data.postgrados),
            objEspecificos: setListProductoEspecifico(data.objEspecificos) as Array<ProductoObjEspecifico>,
            factorImpacto: SetListProductoFactorImpacto(data.factorImpacto) as Array<ProductoFactorImpacto>,
            resultados: setListProductoResultado(data.resultados),
            idpersona: idpersona,
            idCategoriaProducto: data.idCategoriaProducto as number,
            eid: data.eid
        });
        setListSubaArea(data.areaConocimiento.codarea);
        setListSubaAreaDet(data.areaConocimiento.codsubarea);
        listRolAjust(data.producto.iddecinvtipoproductoesperado);
        manjeoTipoPatente(data.producto.iddecinvtipoproductoesperado);
        manjeoProgramasPostgrado(data.producto.iddecinvtipoproductoesperado);
        if (data.producto.iddecinvproyecto > 0) {
            setListColaboradores(data.producto.iddecinvproyecto);
        }
        //console.log(datosFormulario);
    }
    function FactorImpactoHandler(nameIndex: string, factorImpacto: Array<ProductoFactorImpacto>): ProductoFactorImpacto {
        let factor = factorImpacto.find(x => x.nombreindexacion == nameIndex) ?? GetVoidProductoFactorImpacto();
        return factor;
    }
    function FactorImpactoCreator(iddecinvproductofactorimpacto: number, iddecinvproyectoprodtermin: number, nombreindexacion: string, factorimpacto: string, cuartil: string, esprimerdecil: string): ProductoFactorImpacto {
        let factor = GetVoidProductoFactorImpacto();
        factor.iddecinvproductofactorimpacto = iddecinvproductofactorimpacto;
        factor.iddecinvproyectoprodtermin = iddecinvproyectoprodtermin;
        factor.nombreindexacion = nombreindexacion;
        factor.factorimpacto = factorimpacto;
        factor.cuartil = cuartil;
        factor.esprimerdecil = esprimerdecil;
        return factor;
    }
    function usoParticipacion(id: number): boolean {
        let flat = false;
        if ([32, 34].includes(id)) {
            flat = true;
        }
        return flat;
    }
    function noUsoTitularidad(id: number): boolean {
        let flat = false;
        if ([45].includes(id)) {
            flat = true;
        }
        return flat;
    }
    function FormTitleColHandle(id: number): string {
        let flat = '';
        if ([33, 35, 36, 43].includes(id)) {
            flat = 'Autores';
        } else if ([32].includes(id)) {
            flat = 'Inventores/diseñadores';
        }
        else if ([34].includes(id)) {
            flat = 'Inventores u Obtentores';
        } else if ([44].includes(id)) {
            flat = 'Inventores';
        }
        else if ([37].includes(id)) {
            flat = 'Custodio';
        } else if ([38].includes(id)) {
            flat = 'Responsable';
        } else if ([39, 40].includes(id)) {
            flat = 'Organizadores';
        } else {
            flat = 'Colaboradores';
        }
        return flat;
    }
    function FormTypeHandle(id: number, name: string): boolean {
        let flat = true;
        switch (id) {
            case 7://Libro/Capitulo de libro ANTIGUO
                let campos7 = ['anio', 'fechapublicacion', 'editorial', 'volumen', 'paginas', 'url', 'bdrevista', 'codISSN', 'doi', 'revisionpares'];
                flat = campos7.includes(name);
                break;
            case 17://Infraestructura/Laboratorio antiguo
                let campos17 = ['idunidad', 'tipolab', 'nevento', 'levento', 'resumen'];
                flat = campos17.includes(name);
                break;
            case 12://Infraestructura/Equipamento antiguo
                let campos12 = ['idunidad', 'levento', 'fevento', 'marca', 'modelo', 'serie', 'fechapublicacion', 'fevento', 'inventario', 'estado', 'isindex', 'frecuencia', 'asistObjetiv', 'especificacion'];
                flat = campos12.includes(name);
                break;
            case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
                let campos = ['anio', 'url', 'doi', 'fechapublicacion', 'bdrevista', 'nombreRevista', 'codISSN', 'urlRevista', 'impactoIndex', 'impactoSJR', 'cuartil', 'volumen', 'paginas', 'palabrasClave', 'resumen', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'adjunto'];
                flat = campos.includes(name);
                break;
            case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES)
                let campos26 = ['anio', 'url', 'doi', 'fechapublicacion', 'bdrevista', 'nombreRevista', 'codISSN', 'urlRevista', 'volumen', 'paginas', 'palabrasClave', 'resumen', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'adjunto'];
                flat = campos26.includes(name);
                break;
            case 26://ARTÍCULO CIENTÍFICO (SIN INDEXACIÓN)
                let campos25 = ['anio', 'url', 'doi', 'fechapublicacion', 'nombreRevista', 'codISSN', 'revisionpares', 'volumen', 'paginas', 'palabrasClave', 'resumen', 'adjunto', 'adjunto2'];
                flat = campos25.includes(name);
                break;
            case 27://ARTÍCULO DE DIVULGACIÓN CIENTÍFICA
                let campos27 = ['anio', 'url', 'doi', 'fechapublicacion', 'nombreRevista', 'codISSN', 'palabrasClave', 'resumen', 'adjunto'];
                flat = campos27.includes(name);
                break;
            case 28://Libro/Capitulo de libro
                let campos28 = ['anio', 'fechapublicacion', 'editorial', 'volumen', 'paginas', 'url', 'bdrevista', 'codISSN', 'doi', 'revisionpares', 'adjunto', 'adjunto2', 'adjunto3'];
                flat = campos28.includes(name);
                break;
            case 29://TESIS MAESTRÍA DE INVESTIGACIÓN
                let campos29 = ['url', 'fevento', 'palabrasClave', 'objGeneral', 'objEspecificos', 'programaPostgrado', 'resumen', 'adjunto', 'adjunto2'];
                flat = campos29.includes(name);
                break;
            case 30://TESIS DE DOCTORADO
                let campos30 = ['url', 'fevento', 'palabrasClave', 'objGeneral', 'objEspecificos', 'programaPostgrado', 'resumen', 'adjunto', 'adjunto2'];
                flat = campos30.includes(name);
                break;
            case 31://ABSTRACT CONFERENCIA
                let campos31 = ['url', 'nombreRevista', 'codISSN', 'nevento', 'levento', 'fevento', 'palabrasClave', 'adjunto', 'adjunto2'];
                flat = campos31.includes(name);
                break;
            case 32://Solicitud de Patente
                let campos32 = ['solicitantes', 'numsolicitud', 'subclase', 'proyectorel', 'casillaMateriaInt', 'casillaPais', 'idpais', 'instTitular', 'nevento', 'fechapublicacion', 'fevento', 'iddecinvobjods', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'resumen', 'palabrasClave', 'adjunto', 'adjunto2', 'adjunto3', 'adjunto4', 'adjunto5'];
                flat = campos32.includes(name);
                break;
            case 33://Derecho de Autor
                let campos33 = ['solicitantes', 'numsolicitud', 'iddecinvobjods', 'subclase', 'casillaMateriaInt', 'fevento', 'especificacion', 'adjunto', 'adjunto2'];
                flat = campos33.includes(name);
                break;
            case 34://NUEVA OBTENCION VEGETAL
                let campos34 = ['solicitantes', 'numsolicitud', 'proyectorel', 'casillaPais', 'idpais', 'instTitular', 'nevento', 'fechapublicacion', 'fevento', 'iddecinvobjods', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'resumen', 'palabrasClave', 'adjunto', 'adjunto2'];
                flat = campos34.includes(name);
                break;
            case 35://CASO ESTUDIO
                let campos35 = ['url', 'fechapublicacion', 'nombreRevista', 'objEspecificos', 'resultados', 'resumen', 'especificacion', 'adjunto', 'adjunto2'];
                flat = campos35.includes(name);
                break;
            case 36://POSTER CONFERENCIA
                let campos36 = ['nombreRevista', 'nevento', 'levento', 'fevento', 'adjunto', 'adjunto2'];
                flat = campos36.includes(name);
                break;
            case 37://Infraestructura/Equipamento
                let campos37 = ['idunidad', 'levento', 'marca', 'modelo', 'serie', 'fechapublicacion', 'fevento', 'inventario', 'estado', 'isindex', 'frecuencia', 'especificacion', 'adjunto'];
                flat = campos37.includes(name);
                break;
            case 38://Infraestructura/Laboratorio
                let campos38 = ['idunidad', 'tipolab', 'nevento', 'levento', 'resumen', 'adjunto'];
                flat = campos38.includes(name);
                break;
            case 39://Organización y ejecución de Taller/Curso/Conferencia
                let campos39 = ['nevento', 'especificacion', 'levento', 'fevento', 'adjunto', 'adjunto2', 'adjunto3'];
                flat = campos39.includes(name);
                break;
            case 40://Metodología/Protocolo implementado
                let campos40 = ['codigoproducto', 'especificacion', 'areaimplementacion', 'adjunto', 'adjunto2', 'adjunto3', 'adjunto4', 'adjunto5'];
                flat = campos40.includes(name);
                break;
            case 41://Proyecto de titulación de Grado
                let campos41 = ['url', 'palabrasClave', 'objGeneral', 'objEspecificos', 'resumen', 'fevento', 'adjunto'];
                flat = campos41.includes(name);
                break;
            case 42://Proyecto de titulación de maestría profesional
                let campos42 = ['url', 'palabrasClave', 'objGeneral', 'objEspecificos', 'programaPostgrado', 'resumen', 'fevento', 'adjunto', 'adjunto2'];
                flat = campos42.includes(name);
                break;
            case 43://Participación en conferencia
                let campos43 = ['nombreRevista', 'nevento', 'levento', 'fevento', 'adjunto'];
                flat = campos43.includes(name);
                break;
            case 44://Secreto Empresarial o información no divulgada
                let campos44 = ['casillaMateriaInt', 'iddecinvobjods', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'fevento', 'adjunto', 'adjunto2'];
                flat = campos44.includes(name);
                break;
            case 45://Informes técnicos de resultados de investigación (Arqueología)
                let campos45 = ['solicitantes', 'subclase', 'paginas', 'palabrasClave', 'resumen', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'anio', 'adjunto', 'adjunto2', 'adjunto3'];
                flat = campos45.includes(name);
                break;
            case 46://ARTÍCULO DE CONFERENCIA (SCOPUS/WOS)
                let campos46 = ['anio', 'url', 'doi', 'fechapublicacion', 'bdrevista', 'nombreRevista', 'codISSN', 'urlRevista', 'impactoIndex', 'impactoSJR', 'cuartil', 'volumen', 'paginas', 'palabrasClave', 'resumen', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'adjunto', 'adjunto2', 'adjunto3'];
                flat = campos46.includes(name);
                break;
            case 47://PRODUCTO TRANSICION
                let campos47 = ['anio', 'url', 'doi', 'subclase', 'adjunto', 'adjunto2', 'adjunto3', 'adjunto4'];
                flat = campos47.includes(name);
                break;
            case 48://AVANCE DOCTORADO
                let campos48 = ['fechapublicacion', 'idprograma', 'adjunto'];
                flat = campos48.includes(name);
                break;
            default:
                flat = false;
                break;
        }
        return flat;
    }
    function FormSubClassHandle(id: number, name: string): boolean {
        let flat = true;
        switch (id) {
            case 3830://Planta transgenica
                let campos1 = ['fechapublicacion', 'asistObjetiv', 'innovaVerific', 'logrosSistemac', 'retosComunic'];
                flat = campos1.includes(name);
                break;
            case 3831://Prototipo
                let campos2 = ['fechapublicacion', 'palabrasClave', 'resumen', 'logrosSistemac'];
                flat = campos2.includes(name);
                break;
            case 3832://Secuencia sintética
                let campos3 = ['objGeneral'];
                flat = campos3.includes(name);
                break;
            case 3833://Software
                let campos4 = ['especificacion'];
                flat = campos4.includes(name);
                break;
            case 3834://Vacuna
                let campos5 = ['fechapublicacion', 'palabrasClave', 'resumen', 'logrosSistemac'];
                flat = campos5.includes(name);
                break;
            case 3835://Transferencia tecnologia
                let campos6 = ['idunidad', 'resumen', 'asistObjetiv'];
                flat = campos6.includes(name);
                break;
            default:
                flat = false;
                break;
        }
        return flat;
    }
    function FormLabelHandle(id: number, name: string): string {
        let label = "";
        switch (id) {
            case 0:
                switch (name) {
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 17://Infraestructura/Laboratorio antiguo
                switch (name) {
                    case 'nevento':
                        label = 'Nombre Laboratorio: '
                        break;
                    case 'levento':
                        label = 'Ubicación: '
                        break;
                    case 'tipolab':
                        label = 'Tipo de Laboratorio: '
                        break;
                    case 'palabrasClave':
                        label = 'Responsable: '
                        break;
                    case 'resumen':
                        label = 'Áreas del Laboratorio: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 12://Infraestructura/Equipamento antiguo
                switch (name) {
                    case 'nevento':
                        label = 'Nombre Laboratorio: '
                        break;
                    case 'levento':
                        label = 'Ubicación: '
                        break;
                    case 'fevento':
                        label = 'Último Mantenimiento - Obligatorio solo si escoge la opción de "USADO": '
                        break;
                    case 'marca':
                        label = 'Marca: '
                        break;
                    case 'modelo':
                        label = 'Modelo: '
                        break;
                    case 'serie':
                        label = 'Número de Serie (ID): '
                        break;
                    case 'invetario':
                        label = 'Número Inventario de ESPOL/ESPOLTECH: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha de Compra - Obligatorio solo si escoge la opción de "NUEVO": '
                        break;
                    case 'palabrasClave':
                        label = 'Responsable: '
                        break;
                    case 'resumen':
                        label = 'Áreas del Laboratorio: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'isindex':
                        label = 'Condiciones de Brindar Servicio: '
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Artículo científico'
                        break;
                    case 'adjunto2':
                        label = 'Certificado de asistencia a conferencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar diapositivas (En caso de que aplique)';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'cuartil':
                        label = '*Cuartil';
                        break;
                    case 'impactoIndex':
                        label = '*Factor Impacto: ';
                        break;
                    case 'impactoSJR':
                        label = '*Factor Impacto: ';
                        break;
                    case 'impactoSciScore':
                        label = '*Factor Impacto: ';
                        break;
                    case 'cuartilCiteScore':
                        label = '*Cuartil';
                        break;
                    case 'esPrimerDecilCiteScore':
                        label = '¿Es Primer Decil?';
                        break;
                    case "doi":
                        label = "*DOI: ";
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case "revisionpares":
                        label = "Tiene revisión por pares: ";
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = '*Url de Publicación: '
                        break;
                    case 'urlRevista':
                        label = '*Url de la revista / Memoria de Evento: '
                        break;
                    case 'volumen':
                        label = '*Volumen: ';
                        break;
                    case 'paginas':
                        label = '*Páginas: ';
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = '*Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = '*Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = '*Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = '*Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = '*Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = '*Línea de investigación y vinculación: ';
                        break;
                    case 'bdrevista':
                        label = '*Tipo de indexación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES)
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Artículo científico'
                        break;
                    case 'adjunto2':
                        label = 'Certificado de asistencia a conferencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar diapositivas (En caso de que aplique)';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'cuartil':
                        label = '*Cuartil';
                        break;
                    case 'impactoIndex':
                        label = '*Factor Impacto: ';
                        break;
                    case 'impactoSJR':
                        label = '*Factor Impacto: ';
                        break;
                    case 'cuartilCiteScore':
                        label = '*Cuartil';
                        break;
                    case 'esPrimerDecilCiteScore':
                        label = '¿Es Primer Decil?';
                        break;
                    case "doi":
                        label = "*DOI: ";
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'urlRevista':
                        label = '*Url de la revista / Memoria de Evento: '
                        break;
                    case "revisionpares":
                        label = "Tiene revisión por pares: ";
                        break;
                    case 'volumen':
                        label = '*Volumen: ';
                        break;
                    case 'paginas':
                        label = '*Páginas: ';
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'urlRevista':
                        label = '*Url de la revista / Memoria de Evento: '
                        break;
                    case 'url':
                        label = '*Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = '*Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = '*Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = '*Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = '*Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = '*Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = '*Línea de investigación y vinculación: ';
                        break;
                    case 'bdrevista':
                        label = '*Tipo de indexación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 26://ARTÍCULO CIENTÍFICO (SIN INDEXACIÓN)
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Artículo científico';
                        break;
                    case 'adjunto2':
                        label = 'Adjuntar Prueba de Revisión de Pares - Obligatorio si tuvo revisión por pares';
                        break;
                    case 'codISSN':
                        label = '*Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'cuartil':
                        label = '*Cuartil';
                        break;
                    case "doi":
                        label = "*DOI: ";
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'paginas':
                        label = '*Páginas: ';
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case "revisionpares":
                        label = "Tiene revisión por pares: ";
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = '*Url de Publicación: '
                        break;
                    case 'volumen':
                        label = '*Volumen: ';
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    default:
                        label = name;
                        break;
                }

                break;
            case 27://ARTÍCULO DE DIVULGACIÓN CIENTÍFICA
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Artículo de divulgación científica';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case "doi":
                        label = "DOI: ";
                        break;
                    case "revisionpares":
                        label = "Tiene revisión por pares: ";
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = '*Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = '*Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 28://Libro/Capitulo de libro
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del libro o capítulo de libro';
                        break;
                    case 'adjunto2':
                        label = '*Adjuntar Prueba de Revisión de Pares - Obligatorio si se coloca SI en revisión por pares';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar Notificación de Aceptación(En caso de que exista)';
                        break;
                    case 'codISSN':
                        label = '*Código Normalización (ISBN/ISSN): '
                        break;
                    case 'editorial':
                        label = '*Editorial: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha Publicación: '
                        break;
                    case 'url':
                        label = '*Url de Publicación: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'paginas':
                        label = '*Páginas: ';
                        break;
                    case 'bdrevista':
                        label = '*Tipo de indexación';
                        break;
                    case "doi":
                        label = "DOI: ";
                        break;
                    case "revisionpares":
                        label = "*Tuvo Revisión por Pares (SI/NO): ";
                        break;
                    case 'volumen':
                        label = '*Volumen: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 29://TESIS MAESTRÍA DE INVESTIGACIÓN
                switch (name) {
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'fevento':
                        label = '*Fecha de titulación: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras claves: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'idprograma':
                        label = '*Nombre del programa de postgrado: '
                        break;
                    case 'nombreprograma':
                        label = '*Nombre del programa de postgrado: '
                        break;
                    case 'instituciontitularPG':
                        label = '*Institución titular del programa de posgrado: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar PDF de tesis'
                        break;
                    case 'adjunto2':
                        label = '*Diploma o certificado de titulación'
                        break;
                    case 'objGeneral':
                        label = '*Objetivo General: '
                        break;
                    case 'objEspecificos':
                        label = 'Objetivos Especificos';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 30://TESIS DE DOCTORADO
                switch (name) {
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'fevento':
                        label = 'Fecha de titulación: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras claves: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'objGeneral':
                        label = '*Objetivo General: '
                        break;
                    case 'objEspecificos':
                        label = 'Objetivos Especificos';
                        break;
                    case 'idprograma':
                        label = '*Nombre del programa de postgrado: '
                        break;
                    case 'nombreprograma':
                        label = '*Nombre del programa de postgrado: '
                        break;
                    case 'instituciontitularPG':
                        label = '*Institución titular del programa de posgrado: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar PDF de tesis'
                        break;
                    case 'adjunto2':
                        label = '*Diploma o certificado de titulación'
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 31://ABSTRACT CONFERENCIA
                switch (name) {
                    case 'nombreRevista':
                        label = '*Organizadores de la conferencia: '
                        break;
                    case 'codISSN':
                        label = '*Código ISSN / ISBN de las memorias de conferencia: '
                        break;
                    case 'nevento':
                        label = '*Nombre de conferencia: '
                        break;
                    case 'levento':
                        label = '*Lugar del evento: '
                        break;
                    case 'fevento':
                        label = '*Fecha del evento: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras claves: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar el Abstract presentado en la conferencia'
                        break;
                    case 'adjunto2':
                        label = '*Adjuntar el certificado de participación en la conferencia'
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 32://Solicitud de Patente
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar Figuras';
                        break;
                    case 'adjunto2':
                        label = '*Adjuntar Descripción';
                        break;
                    case 'adjunto3':
                        label = '*Adjuntar Solicitud de ingreso de Patente';
                        break;
                    case 'adjunto4':
                        label = '*Adjuntar Notificación de ingreso de Patente';
                        break;
                    case 'adjunto5':
                        label = 'Adjuntar PDF de la Patente';
                        break;
                    case 'solicitantes':
                        label = '*Solicitantes o titulares (nombre de institución / persona, porcentaje de titularidad): ';
                        break;
                    case 'subclase':
                        label = '*Tipo de patente: ';
                        break;
                    case 'numsolicitud':
                        label = 'Número de Solicitud: ';
                        break;
                    case 'proyectorel':
                        label = 'Proyectos relacionados: ';
                        break;
                    case 'casillaMateriaInt':
                        label = 'Si proviene de Materia integradora';
                        break;
                    case 'casillaPais':
                        label = 'Si proviene de otro país';
                        break;
                    case 'idpais':
                        label = 'País';
                        break;
                    case 'instTitular':
                        label = '*Institución que realiza la solicitud: ';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = '*Ente/Organismo competente: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha de presentación a la Oficina Institucional de PI: '
                        break;
                    case 'fevento':
                        label = '*Fecha de presentación al Ente / Organismo competente: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'resumen':
                        label = '*Resumen técnico: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = '*ODS al que contribuye el producto: '
                        break;
                    case 'codarea':
                        label = '*Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = '*Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = '*Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = '*Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = '*Línea de investigación y vinculación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 33://Derecho de Autor
                switch (name) {
                    case 'adjunto':
                        label = '*Registro de derecho de autor'
                        break;
                    case 'adjunto2':
                        label = '*Aduntar Notificación de registro'
                        break;
                    case 'casillaMateriaInt':
                        label = 'Si proviene de Materia integradora';
                        break;
                    case 'subclase':
                        label = 'Clase de obra: ';
                        break;
                    case 'solicitantes':
                        label = '*Titulares (nombre de institución / persona, porcentaje de titularidad): ';
                        break;
                    case 'numsolicitud':
                        label = '*N° certificado: ';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = '*Fecha de registro: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = '*Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = '*ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                }
                break;
            case 34://NUEVA OBTENCION VEGETAL
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar Solicitud de ingreso de Derecho Obtentor'
                        break;
                    case 'adjunto2':
                        label = '*Adjuntar Notificación de ingreso de Derecho Obtentor'
                        break;
                    case 'solicitantes':
                        label = '*Solicitantes o titulares (nombre de institución / persona, porcentaje de titularidad): ';
                        break;
                    case 'subclase':
                        label = 'Tipo de patente: ';
                        break;
                    case 'numsolicitud':
                        label = '*Número de Solicitud: ';
                        break;
                    case 'proyectorel':
                        label = 'Proyectos relacionados: ';
                        break;
                    case 'casillaMateriaInt':
                        label = 'Si proviene de Materia integradora';
                        break;
                    case 'casillaPais':
                        label = 'Si proviene de otro país';
                        break;
                    case 'idpais':
                        label = 'País';
                        break;
                    case 'instTitular':
                        label = '*Institución que realiza la solicitud: ';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = '*Ente / Organismo competente: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = '*Fecha de presentación al Ente / Organismo competente: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'paginas':
                        label = '*Páginas: ';
                        break;
                    case 'resumen':
                        label = '*Resumen Técnico: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha de presentación a la Oficina Institucional de PI: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = '*ODS del producto: '
                        break;
                    case 'codarea':
                        label = '*Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = '*Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = '*Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = '*Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = '*Línea de investigación y vinculación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 35://caso Estudio
                switch (name) {
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'nombreRevista':
                        label = '*Nombre de revista: '
                        break;
                    case 'especificacion':
                        label = '*Metodología: '
                        break;
                    case 'logrosSistemac':
                        label = 'Sistematicidad: ';
                        break;
                    case 'retosComunic':
                        label = 'Comunicabilidad: ';
                        break;
                    case 'objEspecificos':
                        label = 'Objetivos ';
                        break;
                    case 'resultados':
                        label = 'Resultados';
                        break;
                    case 'adjunto':
                        label = 'Adjuntar PDF del caso de estudio';
                        break;
                    case 'adjunto2':
                        label = 'Adjuntar Otra Evidencia'
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 36://POSTER CONFERENCIA
                switch (name) {
                    case 'nombreRevista':
                        label = '*Organizadores de la conferencia: '
                        break;
                    case 'nevento':
                        label = '*Nombre de conferencia: '
                        break;
                    case 'levento':
                        label = '*Lugar del evento: '
                        break;
                    case 'fevento':
                        label = '*Fecha del evento: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar póster de la conferencia';
                        break;
                    case 'adjunto2':
                        label = '*Adjuntar certificado de participación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 37://Infraestructura/Equipamento
                switch (name) {
                    case 'nevento':
                        label = 'Nombre Laboratorio: '
                        break;
                    case 'levento':
                        label = '*Área / Laboratorio: '
                        break;
                    case 'fevento':
                        label = '*Último Mantenimiento - Obligatorio solo si escoge la opción de "USADO": '
                        break;
                    case 'marca':
                        label = '*Marca: '
                        break;
                    case 'modelo':
                        label = '*Modelo: '
                        break;
                    case 'serie':
                        label = '*Número de Serie (ID): '
                        break;
                    case 'inventario':
                        label = '*Número Inventario de ESPOL/ESPOLTECH: '
                        break;
                    case 'estado':
                        label = '*Estado: '
                        break;
                    case 'frecuencia':
                        label = '*Frecuencia de USO: '
                        break;
                    case 'asistObjetiv':
                        label = 'Usuarios: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha de Compra - Obligatorio solo si escoge la opción de "NUEVO": '
                        break;
                    case 'palabrasClave':
                        label = 'Responsable: '
                        break;
                    case 'especificacion':
                        label = '*Especificación Técnica: '
                        break;
                    case 'idunidad':
                        label = '*Unidad: '
                        break;
                    case 'isindex':
                        label = '*Condiciones de Brindar Servicio: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar Ficha técnica del Equipo';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 38://Infraestructura/Laboratorio
                switch (name) {
                    case 'nevento':
                        label = '*Nombre Laboratorio: '
                        break;
                    case 'levento':
                        label = '*Ubicación: '
                        break;
                    case 'tipolab':
                        label = '*Tipo de Laboratorio: '
                        break;
                    case 'palabrasClave':
                        label = 'Responsable: '
                        break;
                    case 'resumen':
                        label = '*Áreas del Laboratorio: '
                        break;
                    case 'idunidad':
                        label = '*Unidad: '
                        break;
                    case 'adjunto':
                        label = '*Informe de creación de laboratorio (imágenes)';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 39://Organización y ejecución de Taller/Curso/Conferencia
                switch (name) {
                    case 'nevento':
                        label = '*Temática: '
                        break;
                    case 'levento':
                        label = '*Lugar: '
                        break;
                    case 'fevento':
                        label = '*Fecha: '
                        break;
                    case 'asistObjetiv':
                        label = 'Asistentes: '
                        break;
                    case 'especificacion':
                        label = '*Requisitos: '
                        break;
                    case 'adjunto':
                        label = '*Presentación del taller';
                        break;
                    case 'adjunto2':
                        label = '*Listado de asistencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar Otro tipo de Evidencia';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 40://Metodología/Protocolo implementado
                switch (name) {
                    case 'codigoproducto':
                        label = '*Código: '
                        break;
                    case 'especificacion':
                        label = '*Especificaciones: '
                        break;
                    case 'areaimplementacion':
                        label = '*Área de Implementación: ';
                        break;
                    case 'adjunto':
                        label = '*Adjuntar PDF del Producto';
                        break;
                    case 'adjunto2':
                        label = 'Adjuntar Notificación de Aceptación(En caso de que exista)';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar Prueba de Revisión de Pares(En caso de ser requerido)';
                        break;
                    case 'adjunto4':
                        label = 'Adjuntar Otro tipo de Evidencia';
                        break;
                    case 'adjunto5':
                        label = 'Adjuntar Planes de manejo y conservación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 41://Proyecto de titulación grado
                switch (name) {
                    case 'fevento':
                        label = '*Fecha de Titulación: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'objGeneral':
                        label = '*Objetivo General: '
                        break;
                    case 'objEspecificos':
                        label = '*Objetivos Especificos';
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'adjunto':
                        label = '*Proyecto integrador (Registrado en CIB)'
                        break;
                    case 'adjunto2':
                        label = '*Diploma o certificado de titulación'
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 42://Proyecto de titulación de maestría profesional
                switch (name) {
                    case 'fevento':
                        label = 'Fecha de Titulación: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'objGeneral':
                        label = '*Objetivo General: '
                        break;
                    case 'objEspecificos':
                        label = 'Objetivos Especificos';
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'idprograma':
                        label = '*Nombre del programa de postgrado: '
                        break;
                    case 'nombreprograma':
                        label = '*Nombre del programa de postgrado: '
                        break;
                    case 'instituciontitularPG':
                        label = '*Institución titular del programa de posgrado: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar PDF de tesis';
                        break;
                    case 'adjunto2':
                        label = '*Diploma o certificado de titulación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 43://Participación en conferencia
                switch (name) {
                    case 'nombreRevista':
                        label = 'Organizadores de la conferencia: '
                        break;
                    case 'nevento':
                        label = 'Nombre de conferencia: '
                        break;
                    case 'levento':
                        label = 'Lugar del evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha del evento: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar certificado de participación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 44://Secreto Empresarial o información no divulgada
                switch (name) {
                    case 'adjunto':
                        label = '*Aduntar Notificación de registro'
                        break;
                    case 'adjunto2':
                        label = '*Registro del depósito de información no divulgada (Secreto)';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'casillaMateriaInt':
                        label = 'Si proviene de Materia integradora';
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = '*Fecha de registro: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = '*ODS del producto: '
                        break;
                    case 'codarea':
                        label = '*Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = '*Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = '*Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = '*Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = '*Línea de investigación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 45://Informes técnicos de resultados de investigación (Arqueología)
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Informe aprobado'
                        break;
                    case 'adjunto2':
                        label = '*Adjuntar evidencia de aprobación del documento';
                        break;
                    case 'adjunto3':
                        label = '*Adjuntar fichas de inventario';
                        break;
                    case 'subclase':
                        label = '*Tipo de informe: ';
                        break;
                    case 'anio':
                        label = '*Año de Publicación: ';
                        break;
                    case 'solicitantes':
                        label = '*Nombre de Institución externa: ';
                        break;
                    case 'codarea':
                        label = '*Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = '*Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = '*Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'paginas':
                        label = '*Páginas: ';
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'iddecinvareaconocimiento':
                        label = '*Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = '*Línea de investigación y vinculación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 46://ARTÍCULO DE CONFERENCIA (SCOPUS/WOS)
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Artículo científico'
                        break;
                    case 'adjunto2':
                        label = '*Certificado de asistencia a conferencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar diapositivas (En caso de que aplique)';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'cuartil':
                        label = 'Cuartil';
                        break;
                    case 'impactoIndex':
                        label = 'Factor Impacto: ';
                        break;
                    case 'impactoSJR':
                        label = 'Factor Impacto: ';
                        break;
                    case 'impactoSciScore':
                        label = 'Factor Impacto: ';
                        break;
                    case 'cuartilCiteScore':
                        label = 'Cuartil';
                        break;
                    case 'esPrimerDecilCiteScore':
                        label = '¿Es Primer Decil?';
                        break;
                    case "doi":
                        label = "*DOI: ";
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case "revisionpares":
                        label = "Tiene revisión por pares: ";
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = '*Url de Publicación: '
                        break;
                    case 'urlRevista':
                        label = '*Url de la revista / Memoria de Evento: '
                        break;
                    case 'volumen':
                        label = '*Volumen: ';
                        break;
                    case 'paginas':
                        label = '*Páginas: ';
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = '*Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = '*Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = '*Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = '*Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = '*Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = '*Línea de investigación y vinculación: ';
                        break;
                    case 'bdrevista':
                        label = '*Tipo de indexación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 47://PRODUCTO DE TRANSCISION
                switch (name) {
                    case 'adjunto':
                        label = ''
                        break;
                    case 'adjunto2':
                        label = '';
                        break;
                    case 'adjunto3':
                        label = '';
                        break;
                    case 'adjunto4':
                        label = '';
                        break;
                    case 'anio':
                        label = '*Año: ';
                        break;
                    case "doi":
                        label = "*DOI: ";
                        break;
                    case "especificacion":
                        label = "*Especificaciones: ";
                        break;
                    case "objGeneral":
                        label = "*Propósito: ";
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'idunidad':
                        label = '*Unidad: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'subclase':
                        label = '*Producto Específico: ';
                        break;
                    case 'url':
                        label = '*Url de Publicación: '
                        break;
                    case 'asistObjetiv':
                        label = '';
                        break;
                    case 'innovaVerific':
                        label = '';
                        break;
                    case 'logrosSistemac':
                        label = '';
                        break;
                    case 'retosComunic':
                        label = '';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 48://AVANCE DOCTORADO
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del informe'
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha de realización de informe: '
                        break;
                    case 'idprograma':
                        label = '*Nombre del Programa Doctoral: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            default:
                switch (name) {
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    case 'asistObjetiv':
                        label = 'Objetividad: ';
                        break;
                    case 'innovaVerific':
                        label = 'Verificabilidad: ';
                        break;
                    case 'logrosSistemac':
                        label = 'Sistematicidad: ';
                        break;
                    case 'retosComunic':
                        label = 'Comunicabilidad: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
        }
        return label;
    }
    function FormSubclaseLabelHandle(idsubclase: number, name: string): string {
        let label = ''
        switch (idsubclase) {
            case 3830://Planta transgenica
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'adjunto4':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = '*Plantas modificadas genéticamente: ';
                        break;
                    case 'innovaVerific':
                        label = '*Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = '*Herramientas: ';
                        break;
                    case 'retosComunic':
                        label = '*Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            case 3831://Prototipo
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'Adjuntar Notificación de Aceptación (en caso de que exista)';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar Prueba de Revisión de Pares (en caso de ser requerido)';
                        break;
                    case 'adjunto4':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = '*Plantas modificadas genéticamente: ';
                        break;
                    case 'innovaVerific':
                        label = '*Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = '*Colecciones: ';
                        break;
                    case 'retosComunic':
                        label = '*Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            case 3832://Secuencia sintética
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'adjunto4':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = '*Plantas modificadas genéticamente: ';
                        break;
                    case 'innovaVerific':
                        label = '*Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = '*Herramientas: ';
                        break;
                    case 'retosComunic':
                        label = '*Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            case 3833://Software
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'adjunto4':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = '*Plantas modificadas genéticamente: ';
                        break;
                    case 'innovaVerific':
                        label = '*Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = '*Herramientas: ';
                        break;
                    case 'retosComunic':
                        label = '*Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            case 3834://Vacuna
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'adjunto4':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = '*Plantas modificadas genéticamente: ';
                        break;
                    case 'innovaVerific':
                        label = '*Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = '*Colecciones: ';
                        break;
                    case 'retosComunic':
                        label = '*Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            case 3835://Transferencia tecnologia
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'adjunto4':
                        label = 'Adjuntar otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = '*Patentes Otorgadas: ';
                        break;
                    case 'innovaVerific':
                        label = '*Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = '*Herramientas: ';
                        break;
                    case 'retosComunic':
                        label = '*Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            default:
                label = '';
        }
        return label;
    }
    function FormGlosaryHandle(name: string, id: number): string {
        let info = "";
        switch (name) {
            case "url":
                info = "Enlace donde consta el producto publicado.";
                break;
            case "anio":
                info = "Año de la publicación del producto en revista física.";
                break;
            case "doi":
                info = "Digital Object Identifies, es un identificador único de las publicaciones electrónicas. Por ejemplo: 10.1016/j.trd.2023.103718";
                break;
            case "fechapublicacion":
                switch (id) {
                    case 32:
                        info = "Fecha de presentación a la Oficina institucional de Propiedad Intelectual.";
                        break;
                    case 34:
                        info = "Fecha de presentación a la Oficina institucional de Propiedad Intelectual.";
                        break;
                    case 37:
                        info = "";
                        break;
                    default:
                        info = "Fecha desde que el producto se encuentra habilitado en línea";
                        break;
                }
                break;
            case "codISSN":
                switch (id) {
                    case 24:
                        info = "ISSN: Número de identificación internacional para publicaciones. [Formato 1234-1234].";
                        break;
                    case 25:
                        info = "ISSN: Número de identificación internacional para publicaciones. [Formato 1234-1234].";
                        break;
                    case 26:
                        info = "ISSN: Número de identificación internacional para publicaciones. [Formato 1234-1234].";
                        break;
                    case 46:
                        info = "ISSN: Número de identificación internacional para publicaciones. [Formato 1234-1234].";
                        break;
                    default:
                        info = "ISSN: Número de identificación internacional para publicaciones. [Formato 1234-1234].\nISBN: Número de identificación internacional para publicaciones de libros. [Formato 978-92-95055-02-5].";
                        break;
                }
                break;
            case "urlRevista":
                info = "Enlace de la revista o conferencia donde se ha publicado el artículo.";
                break;
            case "impactoIndex":
                info = "Factor de impacto otorgado por la base de datos donde se encuentra indexada la revista.";
                break;
            case "impactoSJR":
                info = "Factor de impacto otorgado por la base de datos donde se encuentra indexada la revista.";
                break;
            case "cuartil":
                info = "C1/Q1: primer 25%.\nC2/Q2: entre el 25 y 50%\nC3/Q3: entre 50 y 75%\nC4/Q4: entre 75 y 100%";//\nN/A: No aplica.
                break;
            case "volumen":
                info = "Volumen de la revista en la que se publicó el artículo.";
                break;
            case "iddecinvobjods":
                info = "Objetivos de Desarrollo Sostenible (ODS)";
                break;
            case "codarea":
                info = "Clasificación de los programas educativos y sus respectivas certificaciones por niveles de educación y campos de educación.";
                break;
            case "iddecinvareaconocimiento":
                info = "Son áreas que aportan en la generación y transferencia de investigación orientada a la demanda e innovación para la industria, y soluciones a los problemas del país.";
                break;
            case "lineainvestigacion":
                info = "Enfoque al campo de conocimiento, abarcando inquietudes, prácticas y perspectivas de análisis.";
                break;
            case "nevento":
                switch (id) {
                    case 32:
                        info = "Es el organismo competente para proteger y defender los derechos intelectuales; organizar y administrar la información sobre los registros de todo tipo de derechos de propiedad intelectual.";
                        break;
                    case 34:
                        info = "Es el organismo competente para proteger y defender los derechos intelectuales; organizar y administrar la información sobre los registros de todo tipo de derechos de propiedad intelectual.";
                        break;
                    default:
                        info = "";
                        break;
                }
                break;
            case "levento":
                switch (id) {
                    case 37:
                        info = "Área o laboratorio al cuál pertenece el equipo";
                        break;
                    case 38:
                        info = "Lugar donde se encuentra físicamente el laboratorio.";
                        break;
                    case 39:
                        info = "Ubicación donde se realizó el curso/taller/conferencia.";
                        break;
                    default:
                        info = "Forma: Ciudad, País.";
                        break;
                }
                break;
            case "fevento":
                switch (id) {
                    case 32:
                        info = "";
                        break;
                    case 33:
                        info = "";
                        break;
                    case 34:
                        info = "";
                        break;
                    case 37:
                        info = "";
                        break;
                    case 41:
                        info = "";
                        break;
                    case 42:
                        info = "";
                        break;
                    case 44:
                        info = "";
                        break;
                    default:
                        info = "Para los casos que tengan periodos largos de evento, se requiere la fecha de presentación del producto en el evento/congreso.";
                        break;
                }
                break;
            case "especificacion":
                switch (id) {
                    case 33:
                        info = "Descripción del tipo de obra.";
                        break;
                    case 37:
                        info = "Datos técnicos del equipo.";
                        break;
                    case 39:
                        info = "Requisitos exigidos a los asistentes para el curso/taller/conferencia.";
                        break;
                    default:
                        info = "";
                        break;
                }
                break;
            case "idunidad":
                switch (id) {
                    case 37:
                        info = "Unidad Académica o Centro Institucional donde se encuentra físicamente el equipo o donde pertenece el laboratorio (infraestructura).";
                        break;
                    case 38:
                        info = "Unidad Académica o Centro Institucional donde se encuentra físicamente el equipo o donde pertenece el laboratorio (infraestructura).";
                        break;
                    default:
                        info = "";
                        break;
                }
                break;
            case "inventario":
                switch (id) {
                    case 37:
                        info = "Código de inventario asignado por el departamento de Activos Fijos.";
                        break;
                    default:
                        info = "";
                        break;
                }
                break;
            case "asistObjetiv":
                switch (id) {
                    case 37:
                        info = "Persona o grupo de personas que harán uso del equipo.";
                        break;
                    default:
                        info = "";
                        break;
                }
                break;
            case "resumen":
                switch (id) {
                    case 38:
                        info = "Áreas o divisiones del laboratorio. En caso de ser un solo ambiente, indicar 'No hay divisiones internas'.";
                        break;
                    default:
                        info = "";
                        break;
                }
                break;
            case "solicitantes":
                switch (id) {
                    case 32:
                        info = "Persona natural o jurídica, de titular de derechos sobre cualquier modalidad de Propiedad Intelectual."
                        break;
                    case 34:
                        info = "Persona natural o jurídica, de titular de derechos sobre cualquier modalidad de Propiedad Intelectual."
                        break;
                    case 45:
                        info = "Persona natural o jurídica, de titular de derechos sobre cualquier modalidad de Propiedad Intelectual."
                        break;
                    default:
                        info = "";
                        break;
                }
                break;
            case "subclase":
                switch (id) {
                    default:
                        info = "";
                        break;
                }
                break;
            case "proyectorel":
                switch (id) {
                    case 32:
                        info = "En caso de que el producto se asocie a un proyecto de investigación declarados en la plataforma Gestión de Proyectos.";
                        break;
                    case 34:
                        info = "En caso de que el producto se asocie a un proyecto de investigación declarados en la plataforma Gestión de Proyectos.";
                        break;
                    default:
                        info = "";
                        break;
                }
                break;
            case "casillaMateriaInt":
                info = "En caso de que el producto se asocie a un proyeto de materia integradora";
                break;
            case "adjunto":
                switch (id) {
                    case 38:
                        info = "El informe de creación de laboratorio debe incluir imágenes de la infraestructura para que sea considerado como evidencia.";
                        break;
                    case 39:
                        info = "El documento presentado para el taller/curso o conferencia realizada.";
                        break;
                    case 45:
                        info = "Informe de resultados que fue aprobado por la entidad.";
                        break;
                    default:
                        info = "";
                        break;
                }
                break;
            case "adjunto2":
                switch (id) {
                    case 34:
                        info = "Oficio de notificación por parte de la Oficina de Transferencia Intelectual (OTRI).";
                        break;
                    case 45:
                        info = "Dictamen de finalización *en el caso de informes de arqueología y oficios de evaluación en el caso de inventarios. Para los demás opcional.";
                        break;
                    default:
                        info = "";
                        break
                }
                break;
            case "adjunto3":
                switch (id) {
                    case 45:
                        info = "En el caso de arqueología, se deberá adjuntar el PDF de las fichas SIPCE aprobadas. Para los demás opcional.";
                        break;
                    default:
                        info = "";
                        break
                }
                break;
            case "adjunto4":
                switch (id) {
                    default:
                        info = "";
                        break
                }
                break;
            case "adjunto5":
                switch (id) {
                    default:
                        info = "";
                        break
                }
                break;
            default:
                info = "";
                break;
        }
        return info
    }
    function validarPorcentajePart(colaboradores: Array<ProductoColaboradorDTO>, tipo: number): boolean {
        let total = 0;
        colaboradores.forEach(element => {
            // Convierte el valor a número utilizando parseFloat
            const porcentajeComoNumero = parseFloat(element.porcentajeparticipacion.toString());

            // Verifica si la conversión fue exitosa y el valor no es NaN
            if (!isNaN(porcentajeComoNumero)) {
                total = total + porcentajeComoNumero;
                //console.log(total);
            } else {
                console.error(`El valor "${element.porcentajeparticipacion}" no es un número válido.`);
                total = total + 0;
            }
        });
        if (!usoParticipacion(tipo)) {
            total = 100
        }
        return total === 100;
    }
    function validarTipoColaborador(colaboradores: Array<ProductoColaboradorDTO>, producto: number, tiposProductos: Array<number>, tipoCol: number): boolean {
        let bandera = false;
        const colaboradorEspc = colaboradores.filter(x => x.tipoparticipacion === tipoCol);
        if (tiposProductos.includes(producto)) {
            if (colaboradorEspc.length > 0)
                //verifica que almenos tenga 1
                bandera = true
        } else {
            //Si no es un producto que deba validar el colaborador, siemrpe sera true
            bandera = true
        }
        return bandera;
    }
    function validarSoyColaborador(colaboradores: Array<ProductoColaboradorDTO>, correoCreador: string, cedulaCreador: string): boolean {
        let bandera = false;
        const colaboradorEspc = colaboradores.filter(x => x.email === correoCreador);
        const colaboradorEspCedula = colaboradores.filter(x => x.cedula === cedulaCreador);
        if (colaboradorEspc.length > 0 || colaboradorEspCedula.length > 0)
            bandera = true
        return bandera;
    }
    function ListEstadoProyectoHandle(listIndex: Array<CatagNumberDTO>, id: number): string {
        let op = listIndex.find(x => x.codigo == id);
        let str = "";
        if (op != null) {
            str = op.infoExtra ?? "";
        }
        return str;
    }
    function ListIndexHandle(listProyectos: Array<IndexacionDTO>, id: number): Array<IndexacionDTO> {
        let list = listIndex;
        switch (id) {
            case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
                list = list.filter(x => x.catagPadre === 'INDEXACION-SCOPUS-WOS');
                break;
            case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES) 
                list = list.filter(x => x.catagPadre === 'OTRAS-INDEXACIONES');
                break;
            case 7://Libro o capitulo  ANTIGUO
                list = list.filter(x => x.catagPadre === 'INDEXACION-SCOPUS-WOS' || x.catagPadre === 'OTRAS-INDEXACIONES');
                break;
            case 28://Libro o capitulo 
                list = list.filter(x => x.catagPadre === 'INDEXACION-SCOPUS-WOS' || x.catagPadre === 'OTRAS-INDEXACIONES');
                break;
            case 46://ARTÍCULO DE CONFERENCIA (SCOPUS/WOS)
                list = list.filter(x => x.catagPadre === 'INDEXACION-SCOPUS-WOS');
                break;
            default:
                break;
        }
        return list;
    }
    const verificarNumeroEnLista = (numero: number, listaNumeros: number[]): boolean => {
        // Si la lista está vacía, retornamos false
        if (listaNumeros.length === 0) {
            return false;
        }
        // Verificamos si el número está en la lista
        return !listaNumeros.includes(numero);
    };
    const guardarBorrador = async (values: any) => {
        //console.log("Post",values);
        values.estadoproducto = 'G'
        save(values);
    }
    const guardar = async (values: any) => {
        //console.log("Post",values);
        values.estadoproducto = 'C'
        save(values);
    }
    const save = async (values: any) => {
        //console.log("Post", values);
        const fechaNula = new Date(1, 0, 1);
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        let productoFinal = getVoidProdcutoTerminadoDTO();
        productoFinal.idpersona = idpersona;
        productoFinal.eid = datosFormulario.eid;
        productoFinal.ultimocambio = formatDate(fechaHoy);
        //console.log(values.proyectorel); 
        alertaService.showLoading("Espere...");
        //Motivo
        productoFinal.motivo.iddecinvmotivoprodtermin = values.iddecinvmotivoprodtermin;
        productoFinal.motivo.idpersona = values.idusuariocrea === 0 ? idusuariocrea : values.idusuariocrea;
        productoFinal.motivo.tipomotivo = values.tipomotivo;
        productoFinal.motivo.motivo = values.motivo;
        productoFinal.motivo.ultimoCambio = formatDate(fechaHoy);
        if (values.tieneProyecto === 'S') {
            productoFinal.motivo.iddecinvmotivoprodtermin = values.iddecinvmotivoprodtermin;
            productoFinal.motivo.idpersona = values.idusuariocrea === 0 ? idusuariocrea : values.idusuariocrea;
            productoFinal.motivo.tipomotivo = 'O';
            productoFinal.motivo.motivo = 'PRODUCTO INGRESADO AL PROYECTO POR ' + nombresUsuario + " " + apellidosUsuario;
            productoFinal.motivo.ultimoCambio = formatDate(fechaHoy);
        }
        //Producto      
        productoFinal.producto.iddecinvproyectoprodtermin = values.idproductoterminado;
        productoFinal.producto.iddecinvproyecto = values.idproyecto;
        if (values.tieneProyecto === 'N') {
            productoFinal.producto.iddecinvproyecto = 0;
        }
        productoFinal.producto.iddecinvmotivoprodtermin = values.idmotivo;
        productoFinal.producto.titulo = values.titulo;
        productoFinal.producto.iddecinvtipoproductoesperado = values.tipo;
        productoFinal.producto.anio = values.anio;
        productoFinal.producto.url = values.url;
        productoFinal.producto.doi = values.doi;
        productoFinal.producto.bdrevista = values.bdrevista;
        productoFinal.producto.nombrerevista = values.nombreRevista;
        productoFinal.producto.issn = values.codISSN;
        //productoFinal.producto.urlrevista = values.urlRevista;
        productoFinal.producto.factimpacto = values.impactoIndex;
        productoFinal.producto.sjr = values.impactoSJR;
        productoFinal.producto.cuartil = values.cuartil;
        productoFinal.producto.volumen = values.volumen;
        productoFinal.producto.paginas = values.paginas;
        productoFinal.producto.keys = values.palabrasClave;
        productoFinal.producto.resumen = values.resumen;
        productoFinal.producto.revisionpares = values.revisionpares;
        productoFinal.producto.idunidad = values.idunidad;
        productoFinal.producto.nevento = values.nevento;
        productoFinal.producto.levento = values.levento;
        productoFinal.producto.estado = values.estado;
        productoFinal.producto.marca = values.marca;
        productoFinal.producto.modelo = values.modelo;
        productoFinal.producto.serie = values.serie;
        productoFinal.producto.inventario = values.inventario;
        productoFinal.producto.estado = values.estado;
        productoFinal.producto.frecuencia = values.frecuencia;
        productoFinal.producto.asistObjetiv = values.asistObjetiv;
        productoFinal.producto.especificacion = values.especificacion;
        productoFinal.producto.isindex = values.isindex;
        productoFinal.producto.editorial = values.editorial;
        productoFinal.producto.estadopublicacion = values.estadopublicacion;
        productoFinal.producto.innovaVerific = values.innovaVerific;
        productoFinal.producto.logrosSistemac = values.logrosSistemac;
        productoFinal.producto.retosComunic = values.retosComunic;
        productoFinal.producto.iddecinvrevista = values.iddecinvrevista;
        productoFinal.producto.aprobado = values.aprobado;
        productoFinal.producto.observacionarpob = values.observacionarpob;
        productoFinal.producto.idpublicacionpersona = values.idpublicacionpersona;
        productoFinal.producto.codigoproducto = values.codigoproducto;
        productoFinal.producto.tipotesis = values.tipotesis;
        productoFinal.producto.inventor = values.inventor;
        productoFinal.producto.subclase = values.subclase;
        productoFinal.producto.urlrevista = values.urlRevista;
        productoFinal.producto.numerosolicitud = values.numsolicitud;
        productoFinal.producto.objgeneral = values.objGeneral;
        productoFinal.producto.materiaintegradora = values.casillaMateriaInt ? 'S' : 'N';
        productoFinal.producto.estadoproducto = values.estadoproducto;
        productoFinal.producto.tipolab = values.tipolab;
        //Archivos ?
        // productoFinal.producto.adjunto = values.adjunto;
        // productoFinal.producto.adjunto2 = values.adjunto2;
        // productoFinal.producto.adjunto3 = values.adjunto3;
        // productoFinal.producto.adjunto4 = values.adjunto4;
        productoFinal.adjuntos = values.adjuntos;
        //Control fechas
        productoFinal.producto.fechapublicacion = formatDate(fechaNula);
        if (FormTypeHandle(values.tipo, 'fechapublicacion')) {
            productoFinal.producto.fechapublicacion = formatDate(values.fechapublicacion);
        }
        productoFinal.producto.fvencimiento = formatDate(fechaNula);
        if (FormTypeHandle(values.tipo, 'fvencimiento')) {
            productoFinal.producto.fvencimiento = formatDate(values.fvencimiento);
        }
        productoFinal.producto.fevento = formatDate(fechaNula);
        if (FormTypeHandle(values.tipo, 'fevento')) {
            productoFinal.producto.fevento = values.fevento;
        }
        productoFinal.producto.ultimoCambio = formatDate(fechaHoy);
        //AreaConocimiento
        productoFinal.areaConocimiento.iddecinvproductoareaconocimiento = values.iddecinvproductoareaconocimiento;
        productoFinal.areaConocimiento.iddecinvproyectoprodtermin = values.idproductoterminado;
        productoFinal.areaConocimiento.iddecinvtipoproductoesperado = values.tipo;
        productoFinal.areaConocimiento.codarea = values.codarea;
        productoFinal.areaConocimiento.codsubarea = values.codsubarea;
        productoFinal.areaConocimiento.codsubareadetallada = values.codsubareadetallada;
        productoFinal.areaConocimiento.ultimoCambio = formatDate(fechaHoy);
        //lineaInvestigacion
        productoFinal.lineaInvestigacion.iddecinvproductolineainvestigacion = values.iddecinvproductolineainvestigacion;
        productoFinal.lineaInvestigacion.iddecinvproyectoprodtermin = values.idproductoterminado;
        productoFinal.lineaInvestigacion.iddecinvtipoproductoesperado = values.tipo;
        productoFinal.lineaInvestigacion.iddecinvareaconocimiento = values.iddecinvareaconocimiento === 0 ? null : values.iddecinvareaconocimiento;
        productoFinal.lineaInvestigacion.lineainvestigacion = values.lineainvestigacion;
        productoFinal.lineaInvestigacion.ultimoCambio = format(fechaHoy, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        //ods
        productoFinal.ods.iddecinvproductoterminadoobjods = values.iddecinvproductoterminadoobjods;
        productoFinal.ods.iddecinvproyectoprodtermin = values.idproductoterminado;
        productoFinal.ods.iddecinvtipoproductoesperado = values.tipo;
        productoFinal.ods.iddecinvobjods = values.iddecinvobjods;
        productoFinal.ods.ultimoCambio = format(fechaHoy, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX");
        //Colaboladores 
        productoFinal.colProducto = values.colaboradores;
        //Obj Especificos
        productoFinal.objEspecificos = values.objEspecificos;
        //Resultados
        productoFinal.resultados = setListProductoResultado(values.resultados);
        //Solicitantes
        productoFinal.solicitantes = values.solicitantes;
        //institucion pais
        productoFinal.institucion.iddecinvproductoinstitucionpais = values.iddecinvproductoinstitucionpais;
        productoFinal.institucion.iddecinvproyectoprodtermin = values.idproductoterminado;
        productoFinal.institucion.instituciontitular = values.instTitular;
        productoFinal.institucion.idpais = values.idpais;
        productoFinal.institucion.ultimoCambio = fechaHoy;
        //ProyectoRelacionados
        productoFinal.proyectorel = values.proyectorel;
        //postgrado
        productoFinal.postgrados.iddecinvproductoprogramapostgrado = values.iddecinvproductoprogramapostgrado;
        productoFinal.postgrados.iddecinvproyectoprodtermin = values.idproductoterminado;
        productoFinal.postgrados.espol = values.espol ? 'S' : 'N';
        productoFinal.postgrados.idprograma = values.idprograma;
        productoFinal.postgrados.nombreprograma = values.nombreprograma;
        productoFinal.postgrados.instituciontitular = values.instituciontitularPG;
        //factor Impacto 'impactoIndex','impactoSJR'
        if (FormTypeHandle(values.tipo, "impactoSJR") && values.cuartil != "") {
            let SJR = FactorImpactoCreator(values.idfactorimpactoSJR, values.idproductoterminado, "Scimago Journal Ranking", values.impactoSJR, values.cuartil, "N");
            productoFinal.factorImpacto.push(SJR);
        }
        const banderaIndex = (values.bdrevista === 3799 || values.bdrevista === 3801)
        if (FormTypeHandle(values.tipo, "impactoIndex") && banderaIndex && values.cuartilCiteScore != "") {
            let index = FactorImpactoCreator(values.idfactorimpactoCiteScore, values.idproductoterminado, "CiteScore", values.impactoIndex, values.cuartilCiteScore, values.esPrimerDecilCiteScore);
            productoFinal.factorImpacto.push(index);
        }
        //areaimplementacion
        if (values.areaimplementacion !== 0) {
            productoFinal.areaImplementacion.iddecinvproductoareaimplementacion = values.idproductoareaimplementacion;
            productoFinal.areaImplementacion.areaimplementacion = values.areaimplementacion;
            productoFinal.areaImplementacion.iddecinvproyectoprodtermin = values.idproductoterminado;
        }
        console.log('formulario: ',values);
        //console.log('objeto: ',productoFinal.factorImpacto);
        if(values.colaboradores.length === 0 && values.estadoproducto === 'C'){
            alertaService.alertaAdvertencia("Alerta", "Debe ingresar minimo un colaborador.");
        }
        else if(!validarTipoColaborador(values.colaboradores, values.tipo, [29, 30, 41, 42, 48], 7)) {
            alertaService.alertaAdvertencia("Alerta", "Debe ingresar minimo un Tutor entre los colaboradores.");
        }
        else if (!validarTipoColaborador(values.colaboradores, values.tipo, [41], 10)) {
            alertaService.alertaAdvertencia("Alerta", "Debe ingresar minimo un Evaluador entre los colaboradores.");
        } else if (!validarTipoColaborador(values.colaboradores, values.tipo, [39], 8)) {
            alertaService.alertaAdvertencia("Alerta", "Debe ingresar minimo un Instructor entre los colaboradores.");
        }
        else if (!validarTipoColaborador(values.colaboradores, values.tipo, [39], 9)) {
            alertaService.alertaAdvertencia("Alerta", "Debe ingresar minimo un Asistente entre los colaboradores.");
        }
        else if (!validarTipoColaborador(values.colaboradores, values.tipo, [37], 11)) {
            alertaService.alertaAdvertencia("Alerta", "Debe ingresar minimo un Usuario entre los colaboradores.");
        }
        else {
            if (productoFinal.producto.iddecinvtipoproductoesperado === 32 || productoFinal.producto.iddecinvtipoproductoesperado === 34) {
                let bandera = validarPorcentajePart(productoFinal.colProducto, productoFinal.producto.iddecinvtipoproductoesperado);
                if (!bandera) {
                    alertaService.hideLoading();
                    alertaService.alertaAdvertencia("Error", "El porcentaje de participación de los colocaboradores en total no es 100.");
                } else {
                    console.log(productoFinal)
                    const resp = await productoService.GuardarProductoTerminadoContext(productoFinal, token);
                    alertaService.hideLoading();
                    if (resp.status.isSuccessfully) {
                        alertaService.alertaExito("Exito", "Se guardo el producto.");
                        //goToNavigation('/MisProductos');
                        setResponseData(resp.data);
                        if (parametro.onResponse) {
                            parametro.onResponse(resp.data);
                        } else {
                            console.error('La función onResponse no está definida.');
                        }
                    } else {
                        alertaService.alertaAdvertenciaList("Error", resp.status.messages);
                    }
                }
            } else {
                const resp = await productoService.GuardarProductoTerminadoContext(productoFinal, token);
                alertaService.hideLoading();
                console.log(resp);
                if (resp.status.isSuccessfully) {
                    //console.log(productoFinal.producto.iddecinvtipoproductoesperado)
                    if ([24, 25].includes(productoFinal.producto.iddecinvtipoproductoesperado) && productoFinal.producto.iddecinvproyectoprodtermin === 0) {
                        setResponseData(resp.data);
                        var obt: EmailProductoCreado = setEmailProductoCreado("Ingreso de Producto", user.emailAddress, resp.data);
                        if (modo === 'C') {
                            await emailService.MailProductoCreado(obt, token);
                            alertaService.alertaProductoConferencia('¿El artículo proviene de una conferencia?', 'Si responde afirmativamente la página se recargará para que ingrese la información de dicha conferencia.', resp.data.producto.iddecinvproyectoprodtermin);
                        } else {
                            if (parametro.onResponse) {
                                parametro.onResponse(resp.data);
                            }
                        }
                    } else {
                        if (modo === 'C') {
                            alertaService.alertaExito("Exito", "Se guardo el producto.");
                        } else {
                            alertaService.alertaExito("Exito", "Se guardo borrador del producto.");
                        }
                        //goToNavigation('/MisProductos');
                        setResponseData(resp.data);
                        if (parametro.onResponse) {
                            parametro.onResponse(resp.data);
                        } else {
                            console.error('La función onResponse no está definida.');
                        }
                    }
                } else {
                    alertaService.alertaAdvertenciaList("Alerta", resp.status.messages);
                }
            }
        }
    }
    const handleAddRowEspecificos = (values: { objEspecificos: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const idProd = datosFormulario.producto.iddecinvproyectoprodtermin;
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const fechaNula = new Date(1, 0, 1);
        const newRow = getVoidProductoEspecifico(); // Puedes inicializar los valores según tus necesidades
        setFieldValue('objEspecificos', [...values.objEspecificos, newRow]);
    };
    const handleRemoveRowEspecifico = async (index: number, values: { objEspecificos: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const updatedEspecifico = [...values.objEspecificos];
        console.log(values.objEspecificos);
        const idToRemove = updatedEspecifico[index].iddecinvproductoobjespecifico;
        if (idToRemove === 0) {
            updatedEspecifico.splice(index, 1);
            setFieldValue('objEspecificos', updatedEspecifico);
        } else {
            //aqui colocar funcion para eliminar
            const delEsp = updatedEspecifico[index] as ProductoObjEspecifico;
            //console.log(delEsp);
            const respuesta = await productoService.DeleteObjetivoProducto(delEsp.iddecinvproductoobjespecifico, token);
            if (respuesta.status.isSuccessfully) {
                updatedEspecifico.splice(index, 1);
                setFieldValue('objEspecificos', updatedEspecifico);
                alertaService.alertaExito('Eliminar', 'Objetivo Eliminado');
            } else {
                alertaService.alertaAdvertenciaList('Eliminar', respuesta.status.messages);
            }
        }
    };
    const handleAddRowResultado = (values: { resultados: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const idProd = datosFormulario.producto.iddecinvproyectoprodtermin;
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const fechaNula = new Date(1, 0, 1);
        const newRow = GetVoidProductoResultado(); // Puedes inicializar los valores según tus necesidades
        setFieldValue('resultados', [...values.resultados, newRow]);
    };
    const handleRemoveRowResultado = async (index: number, values: { resultados: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const updatedresultado = [...values.resultados];
        //console.log(values.resultados);
        const idToRemove = updatedresultado[index].iddecinvproductoresultado;
        if (idToRemove === 0) {
            updatedresultado.splice(index, 1);
            setFieldValue('resultados', updatedresultado);
        } else {
            //aqui colocar funcion para eliminar
            const delResult = updatedresultado[index] as ProductoResultado;
            console.log(delResult);
            const respuesta = await productoService.DeleteResultadoProducto(delResult.iddecinvproductoresultado, token);
            if (respuesta.status.isSuccessfully) {
                updatedresultado.splice(index, 1);
                setFieldValue('resultados', updatedresultado);
                alertaService.alertaExito('Eliminar', 'Resultado Eliminado');
            } else {
                alertaService.alertaAdvertenciaList('Eliminar', respuesta.status.messages);
            }
        }
    };
    const handleAddRow = (values: { colaboradores: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const idProd = datosFormulario.producto.iddecinvproyectoprodtermin;
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const fechaNula = new Date(1, 0, 1);
        const newRow = {
            iddecinvproyectoprodtermin: idProd,
            iddecinvproyectocolaboradores: 0,
            iddecinvproyectoprtercol: 0,
            iddecinvproyecto: 0,
            iddecinvrolinvestigador: 0,
            cedula: '',
            tipocolaborador: 2,
            tipoparticipacion: 1,
            nombre: '',
            email: '',
            institucion: '',
            idunidad: 0,
            escolabproyecto: 1,
            enescalafon: '',
            considerarestimulo: '',
            estimulo: '',
            titulosubproyecto: '',
            porcentajeparticipacion: 0,
            fechacheckescalafon: format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
            fechaingresoproyecto: format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
            fechasalidaproyecto: format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
            ultimoCambio: format(fechaHoy, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
        }; // Puedes inicializar los valores según tus necesidades
        setFieldValue('colaboradores', [...values.colaboradores, newRow]);
    };
    const handleAddRowColaborador = (values: { colaboradores: any; }, colaborador: ProyectoColaboradoreDTO, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const idProd = datosFormulario.producto.iddecinvproyectoprodtermin;
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const fechaNula = new Date(1, 0, 1);
        const newRow = {
            iddecinvproyectoprodtermin: idProd,
            iddecinvproyectocolaboradores: colaborador.iddecinvproyectocolaboradores,
            iddecinvproyectoprtercol: 0,
            iddecinvproyecto: colaborador.iddecinvproyecto,
            iddecinvrolinvestigador: colaborador.iddecinvrolinvestigador,
            cedula: colaborador.cedula,
            tipocolaborador: colaborador.tipocolaborador,
            tipoparticipacion: 1,
            nombre: colaborador.nombre,
            email: colaborador.email,
            institucion: colaborador.institucion,
            idunidad: colaborador.idunidad === null ? 0 : colaborador.idunidad,
            escolabproyecto: 1,
            enescalafon: colaborador.enescalafon,
            considerarestimulo: colaborador.considerarestimulo,
            estimulo: colaborador.estimulo,
            titulosubproyecto: colaborador.titulosubproyecto,
            porcentajeparticipacion: colaborador.porcentajeparticipacion || 0,
            fechacheckescalafon: colaborador.fechacheckescalafon || format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
            fechaingresoproyecto: colaborador.fechaingresoproyecto || format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
            fechasalidaproyecto: colaborador.fechasalidaproyecto || format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
            ultimoCambio: format(fechaHoy, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
        }; // Puedes inicializar los valores según tus necesidades
        setFieldValue('colaboradores', [...values.colaboradores, newRow]);
    };
    const handleAddColaboradorInImport = async () => {
        const idProd = datosFormulario.producto.iddecinvproyectoprodtermin;
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const fechaNula = new Date(1, 0, 1);
        await proyectoService.GetDatosPersonalesColaborador('N', emailAddress, token)
            .then((data) => {
                var colaborador = data.listData.find(x => x.email === emailAddress)
                if (colaborador !== null) {
                    const newRow = {
                        iddecinvproyectoprodtermin: idProd,
                        iddecinvproyectocolaboradores: colaborador.iddecinvproyectocolaboradores,
                        iddecinvproyectoprtercol: 0,
                        iddecinvproyecto: colaborador.iddecinvproyecto,
                        iddecinvrolinvestigador: colaborador.iddecinvrolinvestigador,
                        cedula: colaborador.cedula,
                        tipocolaborador: colaborador.tipocolaborador,
                        tipoparticipacion: 1,
                        nombre: colaborador.nombre,
                        email: colaborador.email,
                        institucion: colaborador.institucion,
                        idunidad: colaborador.idunidad === null ? 0 : colaborador.idunidad,
                        escolabproyecto: 2,
                        enescalafon: colaborador.enescalafon,
                        considerarestimulo: colaborador.considerarestimulo,
                        estimulo: colaborador.estimulo,
                        titulosubproyecto: colaborador.titulosubproyecto,
                        porcentajeparticipacion: colaborador.porcentajeparticipacion || 0,
                        fechacheckescalafon: colaborador.fechacheckescalafon || format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
                        fechaingresoproyecto: colaborador.fechaingresoproyecto || format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
                        fechasalidaproyecto: colaborador.fechasalidaproyecto || format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
                        ultimoCambio: format(fechaHoy, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
                    };
                    //console.log(newRow);
                    setDatosFormulario({
                        ...datosFormulario,
                        colProducto: [...datosFormulario.colProducto, newRow]
                    });
                }

            })
            .catch((error) => {
                console.error(error)
            });
        // Puedes inicializar los valores según tus necesidades
        //setFieldValue('colaboradores', [...values.colaboradores, newRow]);
    };
    const handleAddColaboradorProyectoInImport = async (colaboradores: Array<ProyectoColaboradoreDTO>, values: { colaboradores: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const idProd = datosFormulario.producto.iddecinvproyectoprodtermin;
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const fechaNula = new Date(1, 0, 1);
        var colaborador = colaboradores.find(x => x.email === emailAddress)
        setFieldValue('colaboradores', []);
        if (colaborador !== undefined) {
            const newRow = {
                iddecinvproyectoprodtermin: idProd,
                iddecinvproyectocolaboradores: colaborador.iddecinvproyectocolaboradores,
                iddecinvproyectoprtercol: 0,
                iddecinvproyecto: colaborador.iddecinvproyecto,
                iddecinvrolinvestigador: colaborador.iddecinvrolinvestigador,
                cedula: colaborador.cedula,
                tipocolaborador: colaborador.tipocolaborador,
                tipoparticipacion: 1,
                nombre: colaborador.nombre,
                email: colaborador.email,
                institucion: colaborador.institucion,
                idunidad: colaborador.idunidad === null ? 0 : colaborador.idunidad,
                escolabproyecto: 1,
                enescalafon: colaborador.enescalafon,
                considerarestimulo: colaborador.considerarestimulo,
                estimulo: colaborador.estimulo,
                titulosubproyecto: colaborador.titulosubproyecto,
                porcentajeparticipacion: colaborador.porcentajeparticipacion || 0,
                fechacheckescalafon: colaborador.fechacheckescalafon || format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
                fechaingresoproyecto: colaborador.fechaingresoproyecto || format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
                fechasalidaproyecto: colaborador.fechasalidaproyecto || format(fechaNula, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"),
                ultimoCambio: format(fechaHoy, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
            };
            console.log(newRow);
            setFieldValue('colaboradores', [...values.colaboradores, newRow]);
        }
    };
    const handleRemoveRow = async (index: number, values: { colaboradores: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const updatedColaboradores = [...values.colaboradores];
        const idToRemove = updatedColaboradores[index].iddecinvproyectoprtercol;
        if (idToRemove === 0) {
            updatedColaboradores.splice(index, 1);
            setFieldValue('colaboradores', updatedColaboradores);
        } else {
            //aqui colocar funcion para eliminar
            const delCol = updatedColaboradores[index] as ProyectoColaboradoreDTO;
            //console.log(delCol)
            const respuesta = await productoService.DeleteColaboradorProducto(delCol.iddecinvproyecto, delCol.iddecinvproyectocolaboradores, token);
            if (respuesta.status.isSuccessfully) {
                updatedColaboradores.splice(index, 1);
                setFieldValue('colaboradores', updatedColaboradores);
                alertaService.alertaExito('Eliminar', 'Colaborador Eliminado');
            } else {
                alertaService.alertaAdvertenciaList('Eliminar', respuesta.status.messages);
            }
        }
    };
    function isColaboradorSelected(values: { colaboradores: Array<ProductoColaboradorDTO>; }, colaborador: ProyectoColaboradoreDTO): boolean {
        let bandera = false;
        const colEncontrado = values.colaboradores.find(x => x.email === colaborador.email);
        if (colEncontrado) {
            bandera = true;
        }
        return bandera;
    };
    const handleAddRowSolicitante = (values: { solicitantes: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const idProd = datosFormulario.producto.iddecinvproyectoprodtermin;
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        const newRow: ProductoTerminSolicitanteDTO = {
            iddecinvproyectoprodtermin: idProd,
            iddecinvproductoterminsolicitante: 0,
            nombre: "",
            porcentajetitularidad: 0,
            ultimoCambio: format(fechaHoy, "yyyy-MM-dd'T'HH:mm:ss.SSSXXX")
        }; // Puedes inicializar los valores según tus necesidades
        setFieldValue('solicitantes', [...values.solicitantes, newRow]);
    };
    const handleRemoveRowSolicitante = async (index: number, values: { solicitantes: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const updated = [...values.solicitantes];
        const idToRemove = updated[index].iddecinvproductoterminsolicitante;
        if (idToRemove === 0) {
            updated.splice(index, 1);
            setFieldValue('solicitantes', updated);
        } else {
            //aqui colocar funcion para eliminar
            const delSol = updated[index] as ProductoTerminSolicitanteDTO;
            //console.log(delCol)
            const respuesta = await productoService.DeleteSolicitanteProducto(delSol.iddecinvproductoterminsolicitante, token);
            if (respuesta.status.isSuccessfully) {
                updated.splice(index, 1);
                setFieldValue('solicitantes', updated);
                alertaService.alertaExito('Eliminar', 'Solicitante Eliminado');
            } else {
                alertaService.alertaAdvertenciaList('Eliminar', respuesta.status.messages);
            }
        }
    };
    const handleAddProyectoRel = (values: { proyectorel: any; }, proy: CatagNumberDTO, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const newRow = {
            iddecinvproductorelacionproyecto: 0,
            iddecinvproyectoprodtermin: datosFormulario.producto.iddecinvproyectoprodtermin,
            iddecinvproyecto: proy.codigo,
            tituloProyecto: proy.descripcion
        }; // Puedes inicializar los valores según tus necesidades
        setFieldValue('proyectorel', [...values.proyectorel, newRow]);
        console.log(values.proyectorel);
    };
    const handleRemoveProyectoRel = async (index: number, values: { proyectorel: any; }, setFieldValue: (arg0: string, arg1: any[]) => void) => {
        const updatedProyectoRel = [...values.proyectorel];
        const idToRemove = updatedProyectoRel[index].id;
        if (idToRemove === 0) {
            updatedProyectoRel.splice(index, 1);
            setFieldValue('proyectorel', updatedProyectoRel);
        } else {
            //aqui colocar funcion para eliminar
            const delProy = updatedProyectoRel[index] as ProyectoRelacionado;
            console.log(delProy)
            const respuesta = await productoService.DeleteRelacionProyecto(delProy.iddecinvproductorelacionproyecto, token);
            if (respuesta.status.isSuccessfully) {
                updatedProyectoRel.splice(index, 1);
                setFieldValue('proyectorel', updatedProyectoRel);
                alertaService.alertaExito('Eliminar', 'Relación con Proyecto Eliminada');
            } else {
                alertaService.alertaAdvertenciaList('Eliminar', respuesta.status.messages);
            }
        }
        //console.log(updatedProyectoRel);
    };
    function isProyectSelected(values: { proyectorel: Array<ProyectoRelacionado>; }, proy: CatagNumberDTO): boolean {
        let bandera = false;
        const objetoEncontrado = values.proyectorel.find(x => x.iddecinvproyecto === proy.codigo);
        if (objetoEncontrado) {
            bandera = true;
        }
        return bandera;
    }
    async function setListSubaArea(idarea: number) {
        setLoadedSubAreasCine(false);
        await catalogService.obtenerGetSubAreas(idarea)
            .then((data) => {
                //console.log(data.objDatos);
                if (data.status.isSuccessfully) {
                    setSubAreasCine(data.listData);
                    setLoadedSubAreasCine(true);
                }
            })
            .catch((error) => console.error(error));
    };
    async function setListSubaAreaDet(idsubarea: number) {
        setLoadedSubAreasCineDet(false);
        await catalogService.obtenerGetSubAreas(idsubarea)
            .then((data) => {
                //console.log(data.objDatos);
                if (data.status.isSuccessfully) {
                    setSubAreasCineDet(data.listData);
                    setLoadedSubAreasCineDet(true);
                }
            })
            .catch((error) => console.error(error));
    };
    function setListProyectoAreas(idproy: number) {
        proyectoService.GetAreasProyectoById(idproy, token)
            .then((data) => {
                //console.log(data.objDatos);
                setAreasProyecto(data.listData);
            })
            .catch((error) => console.error(error));
    }
    function setListCategoriayTipoProducto(categ: number) {
        //console.log(categ);
    }
    function AreaCineActualizar() {
        if (areasProyecto.length === 1 && datosFormulario.producto.iddecinvproyectoprodtermin === 0) {
            const resp = areasProyecto[0];
            let area: ProductoAreaConocimientoDTO = datosFormulario.areaConocimiento;
            area.codarea = resp.idarea;
            area.codsubarea = resp.idsubarea;
            area.codsubareadetallada = resp.idsubareadet;
            //console.log(data);
            setDatosFormulario({
                ...datosFormulario,
                areaConocimiento: setProductoAreaConocimientoDTO(area) as ProductoAreaConocimientoDTO,
            });
            setListSubaArea(resp.idarea);
            setListSubaAreaDet(resp.idsubarea);
        }
    }
    //#endregion
    //#region Seccion Carga
    useEffect(() => {
        fetchData();
        //console.log(casUserContext.userData);
    }, [token]);
    useEffect(() => {
        simulateLoading();
        //console.log(casUserContext.userData);
    }, [token]);
    useEffect(() => {
        console.log('Cambiaron')
        manjeoProgramasPostgrado(datosFormulario.producto.iddecinvtipoproductoesperado)
    }, [listProgramasDoctorado, listProgramasPostgrado]);
    useEffect(() => {
        if (parametro.importScopus) {
            handleAddColaboradorInImport();
        }
    }, [parametro.productoterminado.producto, parametro.productoterminado.producto.iddecinvproyecto]);
    //#endregion
    if (!ready) {
        return (
            <Stack sx={{ width: '100%' }} spacing={2}>
                <LinearProgress color="primary" />
            </Stack>
        );
    }
    //#region Formulario
    return (
        <div className='formualrioGeneral'>
            <Card>
                <CardHeader style={cardHeaderStyles}>
                    <strong>Formulario Producto</strong>
                    <Tooltip title={"Volver a Mis productos"} placement="left" arrow >
                        <IconButton aria-label="back" color="success" onClick={() => goToNavigation('/Producto/MisProductos')}>
                            <AiFillCaretLeft />
                        </IconButton>
                    </Tooltip>
                </CardHeader>
                <CardBody>
                    <Formik
                        initialValues={{
                            apellidosBusqueda: apellidosBusqueda,
                            mailBusqueda: mailBusqueda,
                            //producto
                            iddecinvmotivoprodtermin: datosFormulario.producto.iddecinvmotivoprodtermin,
                            idusuariocrea: datosFormulario.motivo.idpersona,
                            tipomotivo: datosFormulario.motivo.tipomotivo,
                            motivo: datosFormulario.motivo.motivo,
                            idproductoterminado: datosFormulario.producto.iddecinvproyectoprodtermin,
                            idproyecto: datosFormulario.producto.iddecinvproyecto,
                            tieneProyecto: datosFormulario.producto.iddecinvproyecto === null || datosFormulario.producto.iddecinvproyecto === 0 ? 'N' : 'S',
                            estadoProyecto: datosFormulario.producto.iddecinvproyecto === 0 ? '' : ListEstadoProyectoHandle(misProyectos, datosFormulario.producto.iddecinvproyecto),
                            idmotivo: datosFormulario.producto.iddecinvmotivoprodtermin,
                            titulo: datosFormulario.producto.titulo,
                            tipo: datosFormulario.producto.iddecinvtipoproductoesperado,
                            categoria: datosFormulario.idCategoriaProducto !== null ? datosFormulario.idCategoriaProducto : parametro.defaultCategoria,
                            anio: datosFormulario.producto.anio > 0 ? datosFormulario.producto.anio : anioActual,
                            url: datosFormulario.producto.url,
                            doi: datosFormulario.producto.doi,
                            //fechapublicacion: datosFormulario.producto.fechapublicacion.length > 0 ? convertirFormatoFecha(datosFormulario.producto.fechapublicacion) : format(new Date(),'yyyy-MM-dd'),
                            fechapublicacion: datosFormulario.producto.fechapublicacion.length > 0 ? format(parse(datosFormulario.producto.fechapublicacion, "dd/MM/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(new Date(), 'yyyy-MM-dd'),
                            //fechapublicacion: datosFormulario.producto.fechapublicacion.toFormatYYYYMMD(),
                            bdrevista: datosFormulario.producto.bdrevista,
                            nombreRevista: datosFormulario.producto.nombrerevista,
                            codISSN: datosFormulario.producto.issn,
                            //Index Control
                            idfactorimpactoSJR: FactorImpactoHandler("Scimago Journal Ranking", datosFormulario.factorImpacto).iddecinvproductofactorimpacto ?? 0,
                            impactoSJR: FactorImpactoHandler("Scimago Journal Ranking", datosFormulario.factorImpacto).factorimpacto ?? datosFormulario.producto.sjr,
                            cuartil: FactorImpactoHandler("Scimago Journal Ranking", datosFormulario.factorImpacto).cuartil ?? datosFormulario.producto.cuartil,
                            impactoCiteScore: FactorImpactoHandler("CiteScore", datosFormulario.factorImpacto).factorimpacto ?? datosFormulario.producto.factimpacto,
                            idfactorimpactoCiteScore: FactorImpactoHandler("CiteScore", datosFormulario.factorImpacto).iddecinvproductofactorimpacto ?? 0,
                            impactoIndex: FactorImpactoHandler("CiteScore", datosFormulario.factorImpacto).factorimpacto ?? datosFormulario.producto.factimpacto,
                            cuartilCiteScore: FactorImpactoHandler("CiteScore", datosFormulario.factorImpacto).cuartil ?? "Q1",
                            esPrimerDecilCiteScore: FactorImpactoHandler("CiteScore", datosFormulario.factorImpacto).esprimerdecil ?? "N",
                            //Index Control
                            volumen: datosFormulario.producto.volumen,
                            paginas: datosFormulario.producto.paginas,
                            palabrasClave: datosFormulario.producto.keys,
                            resumen: datosFormulario.producto.resumen,
                            revisionpares: datosFormulario.producto.revisionpares,
                            tipolab: datosFormulario.producto.tipolab,
                            nevento: datosFormulario.producto.nevento,
                            levento: datosFormulario.producto.levento,
                            //fevento: datosFormulario.producto.fevento.length > 0 ? convertirFormatoFecha(datosFormulario.producto.fevento) : format(new Date(),'yyyy-MM-dd'),
                            fevento: datosFormulario.producto.fevento.length > 0 ? format(parse(datosFormulario.producto.fevento, "d/M/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(new Date(), 'yyyy-MM-dd'),
                            // fevento:datosFormulario.producto.fevento.toFormatYYYYMMD(),
                            idunidad: datosFormulario.producto.idunidad,
                            estado: datosFormulario.producto.estado,
                            marca: datosFormulario.producto.marca,
                            modelo: datosFormulario.producto.modelo,
                            serie: datosFormulario.producto.serie,
                            inventario: datosFormulario.producto.inventario,
                            frecuencia: datosFormulario.producto.frecuencia,
                            asistObjetiv: datosFormulario.producto.asistObjetiv,
                            especificacion: datosFormulario.producto.especificacion,
                            isindex: datosFormulario.producto.isindex,
                            editorial: datosFormulario.producto.editorial,
                            estadopublicacion: datosFormulario.producto.estadopublicacion,
                            innovaVerific: datosFormulario.producto.innovaVerific,
                            logrosSistemac: datosFormulario.producto.logrosSistemac,
                            retosComunic: datosFormulario.producto.retosComunic,
                            //fvencimiento: datosFormulario.producto.fvencimiento.length > 0 ? convertirFormatoFecha(datosFormulario.producto.fvencimiento) : format(new Date(),'yyyy-MM-dd'),
                            fvencimiento: datosFormulario.producto.fvencimiento.length > 0 ? format(parse(datosFormulario.producto.fvencimiento, "d/M/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(new Date(), 'yyyy-MM-dd'),
                            //fvencimiento:datosFormulario.producto.fvencimiento.toFormatYYYYMMD(),
                            iddecinvrevista: datosFormulario.producto.iddecinvrevista,
                            aprobado: datosFormulario.producto.aprobado,
                            observacionarpob: datosFormulario.producto.observacionarpob,
                            idpublicacionpersona: datosFormulario.producto.idpublicacionpersona,
                            codigoproducto: datosFormulario.producto.codigoproducto,
                            tipotesis: datosFormulario.producto.tipotesis,
                            inventor: datosFormulario.producto.inventor,
                            subclase: datosFormulario.producto.subclase,
                            urlRevista: datosFormulario.producto.urlrevista,
                            numsolicitud: datosFormulario.producto.numerosolicitud,
                            objGeneral: datosFormulario.producto.objgeneral,
                            casillaMateriaInt: datosFormulario.producto.materiaintegradora === 'S',
                            estadoproducto: datosFormulario.producto.estadoproducto,
                            //proyectorels
                            proyectorel: datosFormulario.proyectorel as Array<ProyectoRelacionado>,
                            //Archivos
                            adjunto: linkDspace(ArchivoHandler(1, datosFormulario.archivosProd).refarchivo ?? ""),
                            adjunto2: linkDspace(ArchivoHandler(2, datosFormulario.archivosProd).refarchivo ?? ""),
                            adjunto3: linkDspace(ArchivoHandler(3, datosFormulario.archivosProd).refarchivo ?? ""),
                            adjunto4: linkDspace(ArchivoHandler(4, datosFormulario.archivosProd).refarchivo ?? ""),
                            adjunto5: linkDspace(ArchivoHandler(5, datosFormulario.archivosProd).refarchivo ?? ""),//datosFormulario.producto.adjunto5,
                            //AreaConocimiento
                            iddecinvproductoareaconocimiento: datosFormulario.areaConocimiento.iddecinvproductoareaconocimiento,
                            codarea: datosFormulario.areaConocimiento.codarea,
                            codsubarea: datosFormulario.areaConocimiento.codsubarea,
                            codsubareadetallada: datosFormulario.areaConocimiento.codsubareadetallada,
                            //Institucion pais
                            iddecinvproductoinstitucionpais: datosFormulario.institucion.iddecinvproductoinstitucionpais,
                            casillaPais: datosFormulario.institucion.idpais !== 1816,
                            instTitular: datosFormulario.institucion.instituciontitular,
                            idpais: datosFormulario.institucion.idpais,
                            //postgrado
                            iddecinvproductoprogramapostgrado: datosFormulario.postgrados.iddecinvproductoprogramapostgrado,
                            espol: datosFormulario.postgrados.espol === "S",
                            idprograma: datosFormulario.postgrados.idprograma,
                            nombreprograma: datosFormulario.postgrados.nombreprograma,
                            instituciontitularPG: datosFormulario.postgrados.instituciontitular,
                            //lineaInvestigacion
                            iddecinvproductolineainvestigacion: datosFormulario.lineaInvestigacion.iddecinvproductolineainvestigacion,
                            iddecinvareaconocimiento: datosFormulario.lineaInvestigacion.iddecinvareaconocimiento,
                            lineainvestigacion: datosFormulario.lineaInvestigacion.lineainvestigacion,
                            //ods
                            iddecinvproductoterminadoobjods: datosFormulario.ods.iddecinvproductoterminadoobjods,
                            iddecinvobjods: datosFormulario.ods.iddecinvobjods,
                            // area implementacion
                            idproductoareaimplementacion: datosFormulario.areaImplementacion.iddecinvproductoareaimplementacion,
                            areaimplementacion: datosFormulario.areaImplementacion.areaimplementacion,
                            //idareaimplementacion: '3807',
                            //colaboradores
                            colaboradores: datosFormulario.colProducto as Array<ProductoColaboradorDTO>,
                            //Solicitantes
                            solicitantes: datosFormulario.solicitantes as Array<ProductoTerminSolicitanteDTO>,
                            //Obj Especificos
                            objEspecificos: datosFormulario.objEspecificos as Array<ProductoObjEspecifico>,
                            //resultados
                            resultados: datosFormulario.resultados as Array<ProductoResultado>,
                            adjuntos: datosFormulario.adjuntos as Array<FileModel>,
                        }}
                        validationSchema={modo === 'C' ? ProductoFormSchema : GuardarFormSchema}
                        onSubmit={modo === 'C' ? guardar : guardarBorrador}
                    >
                        {({ isValid, setFieldValue, values, errors, touched, handleSubmit, handleChange, handleBlur }) => (
                            <Form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    {values.idproductoterminado === 0 && (
                                        <Grid item xs={12} sm={12} md={3} lg={3} >
                                            <FormControl sx={{
                                                m: 1,
                                                backgroundColor:
                                                    parametro.importScopus
                                                        ? COLOR_RESALTAR
                                                        : '#FFFFFF', // blanco por defecto
                                                borderRadius: 1
                                            }} fullWidth error={Boolean(errors.tieneProyecto && touched.tieneProyecto)} >
                                                <InputLabel htmlFor="tieneProyecto">Tiene Proyecto:</InputLabel>
                                                <Select
                                                    labelId="select-tieneProyecto"
                                                    name="tieneProyecto"
                                                    label='Tiene Proyecto:'
                                                    variant="outlined"
                                                    value={values.tieneProyecto}
                                                    onChange={async (e: SelectChangeEvent<string>) => {
                                                        const selectedValue = e.target.value as string;
                                                        // Llama a tu función externa para obtener datos de la API
                                                        try {
                                                            if (selectedValue === 'S') {
                                                                const estado = ListEstadoProyectoHandle(misProyectos, values.idproyecto);
                                                                setFieldValue('estadoProyecto', estado)
                                                            } else {
                                                                setFieldValue('estadoProyecto', '')
                                                            }
                                                            handleChange(e);
                                                        } catch (error) {
                                                            // Maneja el error aquí si es necesario
                                                        }
                                                    }}
                                                    onBlur={handleBlur}
                                                >
                                                    <MenuItem key={'null-tieneProyecto'} value={0}>
                                                        {'SELECCIONE'}
                                                    </MenuItem>
                                                    {tieneproy.map((q) => (
                                                        <MenuItem key={q.value} value={q.value}>
                                                            {q.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <ErrorMessage name='tieneProyecto' className='errorMessage' component="div" />
                                            </FormControl>
                                        </Grid>
                                    )}
                                    {values.idproductoterminado === 0 && values.tieneProyecto === 'N' && (
                                        <>
                                            <Grid item xs={12} sm={12} md={9} lg={9}>
                                                <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.tipomotivo && touched.tipomotivo)} >
                                                    <InputLabel htmlFor="tipomotivo">La razón de no estar asociado a un proyecto:</InputLabel>
                                                    <Select
                                                        labelId="select-tipomotivo"
                                                        name="tipomotivo"
                                                        label='La razón de no estar asociado a un proyecto:'
                                                        variant="outlined"
                                                        value={values.tipomotivo}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    >
                                                        {motivos.map((tipoP) => (
                                                            <MenuItem key={tipoP.value} value={tipoP.value}>
                                                                {tipoP.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    <ErrorMessage name='tipomotivo' className='errorMessage' component="div" />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <Field
                                                    as={TextField}
                                                    name="motivo"
                                                    label="Por favor de una explicación breve del trabajo realizado para lograr este producto:"
                                                    variant="outlined"
                                                    sx={{
                                                        m: 1, width: '100%', backgroundColor:
                                                            parametro.importScopus
                                                                ? COLOR_RESALTAR
                                                                : '#FFFFFF', // blanco por defecto 
                                                    }}
                                                    type="text"
                                                    multiline
                                                    rows={3}
                                                    values={values.motivo}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={Boolean(errors.motivo && touched.motivo)}
                                                    helperText={<ErrorMessage name='motivo' />}
                                                />
                                            </Grid>
                                        </>
                                    )}
                                    {values.tieneProyecto === 'S' && (
                                        <>
                                            <Grid item xs={12} sm={12} md={9} lg={9}>
                                                <Field
                                                    as={TextField}
                                                    name="estadoProyecto"
                                                    label="Estado Proyecto: "
                                                    variant="outlined"
                                                    sx={{ m: 1, width: '100%' }}
                                                    type="text"
                                                    values={values.estadoProyecto}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    error={Boolean(errors.estadoProyecto && touched.estadoProyecto)}
                                                    disabled
                                                    helperText={<ErrorMessage name='estadoProyecto' />}
                                                />
                                            </Grid>
                                        </>
                                    )}
                                    {values.tieneProyecto === 'S' && (
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.idproyecto && touched.idproyecto)} >
                                                <InputLabel htmlFor="idproyecto">Proyecto:</InputLabel>
                                                <Select
                                                    labelId="select-idproyecto"
                                                    name="idproyecto"
                                                    label='Proyecto:'
                                                    variant="outlined"
                                                    value={values.idproyecto}
                                                    onChange={async (e: SelectChangeEvent<number>) => {
                                                        const selectedValue = e.target.value as number;
                                                        // Llama a tu función externa para obtener datos de la API
                                                        try {
                                                            const apiData = await setListColaboradores(selectedValue);
                                                            const estado = ListEstadoProyectoHandle(misProyectos, selectedValue);
                                                            if (parametro.importScopus) {
                                                                await handleAddColaboradorProyectoInImport(colaboradorProyecto, values, setFieldValue);
                                                            }
                                                            setFieldValue('estadoProyecto', estado)
                                                            handleChange(e);
                                                        } catch (error) {
                                                            // Maneja el error aquí si es necesario
                                                        }
                                                    }}
                                                    onBlur={handleBlur}
                                                >
                                                    {misProyectos.length > 0 ? (
                                                        misProyectos.map((tipoP) => (
                                                            <MenuItem key={tipoP.codigo} value={tipoP.codigo}>
                                                                {tipoP.descripcion}
                                                            </MenuItem>
                                                        ))
                                                    )
                                                        : (
                                                            <MenuItem value={''}>No hay proyectos disponibles</MenuItem>
                                                        )}
                                                </Select>
                                                <ErrorMessage name='idproyecto' className='errorMessage' component="div" />
                                            </FormControl>
                                        </Grid>
                                    )}
                                </Grid>
                                <Grid className='siempre' container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Field
                                            as={TextField}
                                            name="titulo"
                                            label="Titulo Producto"
                                            variant="outlined"
                                            sx={{ m: 1, width: '100%' }}
                                            type="text"
                                            values={values.titulo}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        <ErrorMessage name='titulo' className='errorMessage' component="div">
                                            {(error) => (
                                                <Alert severity="error">
                                                    {error}
                                                </Alert>
                                            )}
                                        </ErrorMessage>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.categoria && touched.categoria)} >
                                            <InputLabel htmlFor="categoria">Categoría</InputLabel>
                                            <Select
                                                labelId="select-categoria"
                                                name="categoria"
                                                label='Categoría'
                                                variant="outlined"
                                                value={values.categoria}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            >
                                                {categorias.sort((a, b) => (a.ncategoria - b.ncategoria)).map((cat) => (
                                                    <MenuItem key={'cate-' + cat.iddecinvcategoria} value={cat.iddecinvcategoria} disabled={verificarNumeroEnLista(cat.iddecinvcategoria, parametro.categoriasAvalible)}>
                                                        {cat.nombrecategoria}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            <ErrorMessage name='categoria' className='errorMessage' component="div" />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={6} lg={6}>
                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.tipo && touched.tipo)} >
                                            <InputLabel htmlFor="tipo">Producto</InputLabel>
                                            <Select
                                                labelId="select-tipo"
                                                label='Producto'
                                                variant="outlined"
                                                name="tipo"
                                                value={values.tipo}
                                                onChange={async (e: SelectChangeEvent<number>) => {
                                                    const selectedValue = e.target.value as number;
                                                    // Llama a tu función externa para obtener datos de la API
                                                    try {
                                                        await listRolAjust(selectedValue);
                                                        await manjeoTipoPatente(selectedValue);
                                                        await manjeoProgramasPostgrado(selectedValue);
                                                        handleChange(e);
                                                    } catch (error) {
                                                        // Maneja el error aquí si es necesario
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                            >
                                                {/* Ordenar por nombre */}
                                                {tipoProductos.sort((a, b) => {
                                                    if (a.nombreProducto < b.nombreProducto) return -1;
                                                    if (a.nombreProducto > b.nombreProducto) return 1;
                                                    return 0;
                                                }).filter(x => x.idCategoria === values.categoria).map((tipoP) => (
                                                    <MenuItem key={tipoP.idProducto} value={tipoP.idProducto} disabled={verificarNumeroEnLista(tipoP.idProducto, parametro.tiposAvalible)}>
                                                        {tipoP.nombreProducto}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            <ErrorMessage name='tipo' className='errorMessage' component="div" />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                {values.tipo > 0 && (
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <CardUI sx={{
                                                backgroundColor:
                                                    parametro.importScopus
                                                        ? COLOR_RESALTAR
                                                        : '#FFFFFF'
                                            }}>
                                                <CardContent>
                                                    <Typography gutterBottom variant="h5" component="div">
                                                        {FormTitleColHandle(values.tipo)}
                                                    </Typography>
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>#</TableCell>
                                                                <TableCell>Cedula</TableCell>
                                                                <TableCell>Apellidos y Nombres</TableCell>
                                                                <TableCell>Tipo Colaborador</TableCell>
                                                                <TableCell>Unidad Espol</TableCell>
                                                                <TableCell>Institucion</TableCell>
                                                                <TableCell>Correo</TableCell>
                                                                <TableCell>Rol</TableCell>
                                                                {usoParticipacion(values.tipo) ? <TableCell>% Participacion</TableCell> : <></>}
                                                                <TableCell>Acciones</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {values.colaboradores.map((colaborador, index) => (
                                                                <TableRow key={'col-' + index}>
                                                                    <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                                    <TableCell>
                                                                        <FormControl fullWidth >
                                                                            <Field
                                                                                as={TextField}
                                                                                name={`colaboradores[${index}].cedula`}
                                                                                onChange={handleChange}
                                                                                value={colaborador.cedula}
                                                                                onBlur={handleBlur}
                                                                                InputProps={{
                                                                                    readOnly: colaborador.tipocolaborador === 1,
                                                                                }}
                                                                            />
                                                                            <ErrorMessage name={`colaboradores[${index}].cedula`} className='errorMessage' component="div">
                                                                                {(error) => (
                                                                                    <Alert severity="error">
                                                                                        {error}
                                                                                    </Alert>
                                                                                )}
                                                                            </ErrorMessage>
                                                                        </FormControl>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <FormControl >
                                                                            <Field
                                                                                as={TextField}
                                                                                name={`colaboradores[${index}].nombre`}
                                                                                onChange={handleChange}
                                                                                value={colaborador.nombre}
                                                                                onBlur={handleBlur}
                                                                                InputProps={{
                                                                                    readOnly: colaborador.tipocolaborador === 1,
                                                                                }}
                                                                            />
                                                                            <ErrorMessage name={`colaboradores[${index}].nombre`} className='errorMessage' component="div">
                                                                                {(error) => (
                                                                                    <Alert severity="error">
                                                                                        {error}
                                                                                    </Alert>
                                                                                )}
                                                                            </ErrorMessage>
                                                                        </FormControl>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <FormControl >
                                                                            <Select
                                                                                name={`colaboradores[${index}].tipocolaborador`}
                                                                                value={colaborador.tipocolaborador}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            >
                                                                                {/* Agrega más roles según sea necesario */}
                                                                                {tipoColaborador.map((rol) => (
                                                                                    <MenuItem key={rol.id} value={rol.id}>
                                                                                        {rol.label}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                            <ErrorMessage name={`colaboradores[${index}].tipocolaborador`} className='errorMessage' component="div">
                                                                                {(error) => (
                                                                                    <Alert severity="error">
                                                                                        {error}
                                                                                    </Alert>
                                                                                )}
                                                                            </ErrorMessage>
                                                                        </FormControl>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <FormControl >
                                                                            <Select
                                                                                name={`colaboradores[${index}].idunidad`}
                                                                                value={colaborador.idunidad}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            >
                                                                                {/* Agrega más roles según sea necesario */}
                                                                                <MenuItem key={"null-unidad-col"} value="0">Ninguna</MenuItem>
                                                                                {unidades.map((rol) => (
                                                                                    <MenuItem key={rol.idunidad} value={rol.idunidad}>
                                                                                        {rol.codacad}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                            <ErrorMessage name={`colaboradores[${index}].idunidad`} className='errorMessage' component="div">
                                                                                {(error) => (
                                                                                    <Alert severity="error">
                                                                                        {error}
                                                                                    </Alert>
                                                                                )}
                                                                            </ErrorMessage>
                                                                        </FormControl>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <FormControl >
                                                                            <Field
                                                                                as={TextField}
                                                                                name={`colaboradores[${index}].institucion`}
                                                                                onChange={handleChange}
                                                                                value={colaborador.institucion}
                                                                                onBlur={handleBlur}
                                                                                InputProps={{
                                                                                    readOnly: colaborador.tipocolaborador === 1,
                                                                                }}
                                                                            />
                                                                            <ErrorMessage name={`colaboradores[${index}].institucion`} className='errorMessage' component="div">
                                                                                {(error) => (
                                                                                    <Alert severity="error">
                                                                                        {error}
                                                                                    </Alert>
                                                                                )}
                                                                            </ErrorMessage>
                                                                        </FormControl>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <FormControl >
                                                                            <Field
                                                                                as={TextField}
                                                                                name={`colaboradores[${index}].email`}
                                                                                onChange={handleChange}
                                                                                value={colaborador.email} onBlur={handleBlur}
                                                                                InputProps={{
                                                                                    readOnly: colaborador.tipocolaborador === 1,
                                                                                }}
                                                                            />
                                                                            <ErrorMessage name={`colaboradores[${index}].email`} className='errorMessage' component="div">
                                                                                {(error) => (
                                                                                    <Alert severity="error">
                                                                                        {error}
                                                                                    </Alert>
                                                                                )}
                                                                            </ErrorMessage>
                                                                        </FormControl>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <FormControl >
                                                                            <Select
                                                                                name={`colaboradores[${index}].tipoparticipacion`}
                                                                                value={colaborador.tipoparticipacion}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            >
                                                                                <MenuItem value="0">Seleccionar Rol</MenuItem>
                                                                                {/* Agrega más roles según sea necesario */}
                                                                                {listRolColaborador.map((rol) => (
                                                                                    <MenuItem key={rol.id} value={rol.id}>
                                                                                        {rol.label}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                            <ErrorMessage name={`colaboradores[${index}].tipoparticipacion`} className='errorMessage' component="div">
                                                                                {(error) => (
                                                                                    <Alert severity="error">
                                                                                        {error}
                                                                                    </Alert>
                                                                                )}
                                                                            </ErrorMessage>
                                                                        </FormControl>
                                                                    </TableCell>
                                                                    {usoParticipacion(values.tipo) ?
                                                                        <TableCell>
                                                                            <FormControl >
                                                                                <Field
                                                                                    as={TextField}
                                                                                    name={`colaboradores[${index}].porcentajeparticipacion`}
                                                                                    type="text"
                                                                                    placeholder="100"
                                                                                    value={colaborador.porcentajeparticipacion}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                />
                                                                                <ErrorMessage name={`colaboradores[${index}].porcentajeparticipacion`} className='errorMessage' component="div">
                                                                                    {(error) => (
                                                                                        <Alert severity="error">
                                                                                            {error}
                                                                                        </Alert>
                                                                                    )}
                                                                                </ErrorMessage>
                                                                            </FormControl>
                                                                        </TableCell>
                                                                        : <></>}
                                                                    <TableCell>
                                                                        <IconButton aria-label="Eliminar" color='error' onClick={() => handleRemoveRow(index, values, setFieldValue)}>
                                                                            <AiFillDelete />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                    {/* <ErrorMessage name='colaboradores' className='errorMessage' component="div">
                                                        {(error) => (
                                                            <Alert severity="error">
                                                                {error}
                                                            </Alert>
                                                        )}
                                                    </ErrorMessage> */}
                                                    {validarPorcentajePart(values.colaboradores, values.tipo) ?
                                                        <></> :
                                                        <ErrorMessage name='colaboradores' className='errorMessage' component="div">
                                                            {(error) => (
                                                                <Alert severity="error">
                                                                    El porcentaje de participación de los colaboradores en total no es 100.
                                                                </Alert>
                                                            )}
                                                        </ErrorMessage>
                                                    }
                                                    {validarPorcentajePart(values.colaboradores, values.tipo) ?
                                                        <></> :
                                                        <ErrorMessage name='colaboradores' className='errorMessage' component="div">
                                                            {(error) => (
                                                                <Alert severity="error">
                                                                    El porcentaje de participación de los colaboradores en total no es 100.
                                                                </Alert>
                                                            )}
                                                        </ErrorMessage>
                                                    }
                                                    {validarTipoColaborador(values.colaboradores, values.tipo, [29, 30, 41, 42], 7) ?
                                                        <></> :
                                                        <ErrorMessage name='colaboradores' className='errorMessage' component="div">
                                                            {(error) => (
                                                                <Alert severity="error">
                                                                    No olvide ingresar un Tutor.
                                                                </Alert>
                                                            )}
                                                        </ErrorMessage>
                                                    }
                                                    {validarTipoColaborador(values.colaboradores, values.tipo, [41], 10) ?
                                                        <></> :
                                                        <ErrorMessage name='colaboradores' className='errorMessage' component="div">
                                                            {(error) => (
                                                                <Alert severity="error">
                                                                    No olvide ingresar un Evaluador.
                                                                </Alert>
                                                            )}
                                                        </ErrorMessage>
                                                    }
                                                    {validarTipoColaborador(values.colaboradores, values.tipo, [39], 8) ?
                                                        <></> :
                                                        <ErrorMessage name='colaboradores' className='errorMessage' component="div">
                                                            {(error) => (
                                                                <Alert severity="error">
                                                                    No olvide ingresar un Instructor.
                                                                </Alert>
                                                            )}
                                                        </ErrorMessage>
                                                    }
                                                    {validarTipoColaborador(values.colaboradores, values.tipo, [39], 9) ?
                                                        <></> :
                                                        <ErrorMessage name='colaboradores' className='errorMessage' component="div">
                                                            {(error) => (
                                                                <Alert severity="error">
                                                                    No olvide ingresar un Asistente.
                                                                </Alert>
                                                            )}
                                                        </ErrorMessage>
                                                    }
                                                    {validarTipoColaborador(values.colaboradores, values.tipo, [37], 11) ?
                                                        <></> :
                                                        <ErrorMessage name='colaboradores' className='errorMessage' component="div">
                                                            {(error) => (
                                                                <Alert severity="error">
                                                                    No olvide ingresar un Usuario.
                                                                </Alert>
                                                            )}
                                                        </ErrorMessage>
                                                    }
                                                </CardContent>
                                                <CardActions>
                                                    {values.tieneProyecto === 'S' && (
                                                        <Button aria-label="delete" variant="contained" color="success" onClick={handleOpenModal} endIcon={<AiOutlineUserAdd />}>
                                                            Personal Proyecto
                                                        </Button>
                                                    )}
                                                    <Button aria-label="addEspol" variant="contained" color="info" onClick={handleOpenUserModal} endIcon={<FaRegAddressCard />} >
                                                        Personal Espol
                                                    </Button>
                                                    <Button aria-label="addExt" variant="contained" color="info" onClick={() => handleAddRow(values, setFieldValue)} endIcon={<BiAddToQueue />}>
                                                        Personal Externo
                                                    </Button>
                                                </CardActions>
                                            </CardUI>
                                        </Grid>
                                    </Grid>
                                )}
                                <br />
                                {values.tipo > 0 && (
                                    <>
                                        <Grid container spacing={2}>
                                            {FormTypeHandle(values.tipo, 'anio') && (
                                                <Grid item xs={12} sm={6} md={2} lg={2}>
                                                    <Tooltip title={FormGlosaryHandle('anio', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('anio', values.tipo).length === 0}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.anio && touched.anio)} >
                                                            <InputLabel htmlFor="anio">{FormLabelHandle(values.tipo, 'anio')}</InputLabel>
                                                            <Select
                                                                labelId="select-anio"
                                                                name="anio"
                                                                value={values.anio}
                                                                label={FormLabelHandle(values.tipo, 'anio')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                {anios.map((anio) => (
                                                                    <MenuItem key={anio} value={anio}>
                                                                        {anio}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='anio' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {(FormTypeHandle(values.tipo, 'idunidad') || FormSubClassHandle(values.subclase, 'idunidad')) && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('idunidad', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('idunidad', values.tipo).length === 0}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.idunidad && touched.idunidad)} >
                                                            <InputLabel htmlFor="idunidad">{FormLabelHandle(values.tipo, 'idunidad')}</InputLabel>
                                                            <Select
                                                                labelId="select-idunidad"
                                                                name="idunidad"
                                                                value={values.idunidad}
                                                                label={FormLabelHandle(values.tipo, 'idunidad')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                <MenuItem key={'null-Unidad'} value={0}>
                                                                    {'SELECCIONE UNIDAD'}
                                                                </MenuItem>
                                                                {unidades.map((unidad) => (
                                                                    <MenuItem key={unidad.idunidad} value={unidad.idunidad}>
                                                                        {unidad.nombreunidad}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='idunidad' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'subclase') && (
                                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                                    <Tooltip title={FormGlosaryHandle('subclase', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('subclase', values.tipo).length === 0}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.subclase && touched.subclase)} >
                                                            <InputLabel htmlFor="subclase">{FormLabelHandle(values.tipo, 'subclase')}</InputLabel>
                                                            <Select
                                                                labelId="select-subclase"
                                                                name="subclase"
                                                                value={values.subclase}
                                                                label={FormLabelHandle(values.tipo, 'subclase')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                <MenuItem key={'null-subclase'} value={0}>
                                                                    {'NINGUNO'}
                                                                </MenuItem>
                                                                {tipopatente.sort((a, b) => {
                                                                    if (a.descripcion < b.descripcion) return -1;
                                                                    if (a.descripcion > b.descripcion) return 1;
                                                                    return 0;
                                                                }).map((tipo) => (
                                                                    <MenuItem key={tipo.codigo} value={tipo.codigo}>
                                                                        {tipo.descripcion}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='subclase' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'nevento') && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('nevento', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('nevento', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="nevento"
                                                            label={FormLabelHandle(values.tipo, 'nevento')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.nevento}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.nevento && touched.nevento)}
                                                            helperText={<ErrorMessage name='nevento' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'numsolicitud') && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('numsolicitud', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('numsolicitud', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="numsolicitud"
                                                            label={FormLabelHandle(values.tipo, 'numsolicitud')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.numsolicitud}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.numsolicitud && touched.numsolicitud)}
                                                            helperText={<ErrorMessage name='numsolicitud' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'levento') && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('levento', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('levento', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="levento"
                                                            label={FormLabelHandle(values.tipo, 'levento')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.nevento}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.levento && touched.levento)}
                                                            helperText={<ErrorMessage name='levento' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'marca') && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('marca', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('marca', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="marca"
                                                            label={FormLabelHandle(values.tipo, 'marca')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.marca}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.marca && touched.marca)}
                                                            helperText={<ErrorMessage name='marca' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'modelo') && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('modelo', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('modelo', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="modelo"
                                                            label={FormLabelHandle(values.tipo, 'modelo')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.modelo}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.modelo && touched.modelo)}
                                                            helperText={<ErrorMessage name='modelo' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'serie') && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('serie', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('serie', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="serie"
                                                            label={FormLabelHandle(values.tipo, 'serie')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.serie}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.serie && touched.serie)}
                                                            helperText={<ErrorMessage name='serie' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'inventario') && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('inventario', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('inventario', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="inventario"
                                                            label={FormLabelHandle(values.tipo, 'inventario')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.inventario}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.inventario && touched.inventario)}
                                                            helperText={<ErrorMessage name='inventario' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'estado') && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('estado', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('estado', values.tipo).length === 0}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.estado && touched.estado)} >
                                                            <InputLabel htmlFor="estado">{FormLabelHandle(values.tipo, 'estado')}</InputLabel>
                                                            <Select
                                                                labelId="select-estado"
                                                                name="estado"
                                                                value={values.estado}
                                                                label={FormLabelHandle(values.tipo, 'estado')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                <MenuItem key={'null-Estado'} value={0}>
                                                                    {'SELECCIONE ESTADO'}
                                                                </MenuItem>
                                                                {estadoEquipo.map((estado) => (
                                                                    <MenuItem key={estado.id} value={estado.id}>
                                                                        {estado.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='estado' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'frecuencia') && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('frecuencia', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('frecuencia', values.tipo).length === 0}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.frecuencia && touched.frecuencia)} >
                                                            <InputLabel htmlFor="frecuencia">{FormLabelHandle(values.tipo, 'frecuencia')}</InputLabel>
                                                            <Select
                                                                labelId="select-frecuencia"
                                                                name="frecuencia"
                                                                value={values.frecuencia}
                                                                label={FormLabelHandle(values.tipo, 'frecuencia')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                <MenuItem key={'null-Frecuencia'} value={0}>
                                                                    {'SELECCIONE FRECUENCIA'}
                                                                </MenuItem>
                                                                {frecuencia.map((estado) => (
                                                                    <MenuItem key={estado.id} value={estado.id}>
                                                                        {estado.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='frecuencia' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'tipolab') && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('tipolab', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('tipolab', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="tipolab"
                                                            label={FormLabelHandle(values.tipo, 'tipolab')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.tipolab}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.tipolab && touched.tipolab)}
                                                            helperText={<ErrorMessage name='tipolab' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'url') && (
                                                <Grid item xs={12} sm={6} md={4} lg={9}>
                                                    <Tooltip title={FormGlosaryHandle('url', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('url', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="url"
                                                            label={FormLabelHandle(values.tipo, 'url')}
                                                            variant="outlined"
                                                            sx={{
                                                                m: 1, width: '100%', backgroundColor:
                                                                    parametro.importScopus
                                                                        ? COLOR_RESALTAR
                                                                        : '#FFFFFF'
                                                            }}
                                                            type="text"
                                                            values={values.url}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.url && touched.url)}
                                                            helperText={<ErrorMessage name='url' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'doi') && (
                                                <Grid item xs={12} sm={6} md={4} lg={9}>
                                                    <Tooltip title={FormGlosaryHandle('doi', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('doi', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="doi"
                                                            label={FormLabelHandle(values.tipo, 'doi')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.doi}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.doi && touched.doi)}
                                                            helperText={<ErrorMessage name='doi' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {(FormTypeHandle(values.tipo, 'fechapublicacion') || FormSubClassHandle(values.subclase, 'fechapublicacion')) && (
                                                <Grid item xs={12} sm={6} md={3} lg={3}>
                                                    <Tooltip title={FormGlosaryHandle('fechapublicacion', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('fechapublicacion', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="fechapublicacion"
                                                            label={FormLabelHandle(values.tipo, 'fechapublicacion')}
                                                            variant="outlined"
                                                            sx={{ m: 1, minWidth: '100%' }}
                                                            type="date"
                                                            values={values.fechapublicacion}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.fechapublicacion && touched.fechapublicacion)}
                                                            helperText={<ErrorMessage className='errorMessage' name='fechapublicacion' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'fevento') && (
                                                <Grid item xs={12} sm={6} md={3} lg={3}>
                                                    <Tooltip title={FormGlosaryHandle('fevento', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('fevento', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="fevento"
                                                            label={FormLabelHandle(values.tipo, 'fevento')}
                                                            variant="outlined"
                                                            sx={{ m: 1, minWidth: '100%' }}
                                                            type="date"
                                                            values={values.fevento}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.fevento && touched.fevento)}
                                                            helperText={<ErrorMessage className='errorMessage' name='fevento' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'bdrevista') && (
                                                <Grid item xs={12} sm={6} md={4} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('bdrevista', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('bdrevista', values.tipo).length === 0}>
                                                        <FormControl sx={{
                                                            m: 1, backgroundColor:
                                                                parametro.importScopus
                                                                    ? COLOR_RESALTAR
                                                                    : '#FFFFFF', // blanco por defecto 
                                                        }} fullWidth error={Boolean(errors.bdrevista && touched.bdrevista)} >
                                                            <InputLabel htmlFor="bdrevista">{FormLabelHandle(values.tipo, 'bdrevista')}</InputLabel>
                                                            <Select
                                                                labelId="select-bdrevista"
                                                                name="bdrevista"
                                                                value={values.bdrevista}
                                                                label={FormLabelHandle(values.tipo, 'bdrevista')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                <MenuItem key={'nullBdrevista'} value={0}>
                                                                    NINGUNA
                                                                </MenuItem>
                                                                {ListIndexHandle(listIndex, values.tipo).map((opt) => (
                                                                    <MenuItem key={opt.catagPadre + '-' + opt.codigo} value={opt.id}>
                                                                        {opt.descripcion}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='bdrevista' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'nombreRevista') && (
                                                <Grid item xs={12} sm={6} md={4} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('nombreRevista', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('nombreRevista', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="nombreRevista"
                                                            label={FormLabelHandle(values.tipo, 'nombreRevista')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.nombreRevista}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.nombreRevista && touched.nombreRevista)}
                                                            helperText={<ErrorMessage name='nombreRevista' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'codISSN') && (
                                                <Grid item xs={12} sm={6} md={3} lg={3}>
                                                    <Tooltip title={FormGlosaryHandle('codISSN', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('codISSN', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="codISSN"
                                                            label={FormLabelHandle(values.tipo, 'codISSN')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.codISSN}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.codISSN && touched.codISSN)}
                                                            helperText={<ErrorMessage name='codISSN' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'revisionpares') && (
                                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                                    <Tooltip title={FormGlosaryHandle('revisionpares', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('revisionpares', values.tipo).length === 0}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.revisionpares && touched.revisionpares)} >
                                                            <InputLabel htmlFor="revisionpares">{FormLabelHandle(values.tipo, 'revisionpares')}</InputLabel>
                                                            <Select
                                                                labelId="select-revisionpares"
                                                                name="revisionpares"
                                                                value={values.revisionpares}
                                                                label={FormLabelHandle(values.tipo, 'revisionpares')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                {desicion.map((q) => (
                                                                    <MenuItem key={q.value} value={q.value}>
                                                                        {q.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='revisionpares' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'volumen') && (
                                                <Grid item xs={12} sm={6} md={4} lg={2}>
                                                    <Tooltip title={FormGlosaryHandle('volumen', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('volumen', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="volumen"
                                                            label={FormLabelHandle(values.tipo, 'volumen')}
                                                            variant="outlined"
                                                            sx={{ m: 1, minWidth: '100%' }}
                                                            type="text"
                                                            values={values.volumen}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.volumen && touched.volumen)}
                                                            helperText={<ErrorMessage name='volumen' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'paginas') && (
                                                <Grid item xs={12} sm={6} md={4} lg={2}>
                                                    <Tooltip title={FormGlosaryHandle('paginas', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('paginas', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="paginas"
                                                            label={FormLabelHandle(values.tipo, 'paginas')}
                                                            variant="outlined"
                                                            sx={{
                                                                m: 1, minWidth: '100%', backgroundColor:
                                                                    parametro.importScopus
                                                                        ? COLOR_RESALTAR
                                                                        : '#FFFFFF'
                                                            }}
                                                            type="text"
                                                            values={values.paginas}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.paginas && touched.paginas)}
                                                            helperText={<ErrorMessage name='paginas' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'urlRevista') && (
                                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                                    <Tooltip title={FormGlosaryHandle('urlRevista', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('urlRevista', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="urlRevista"
                                                            label={FormLabelHandle(values.tipo, 'urlRevista')}
                                                            variant="outlined"
                                                            sx={{
                                                                m: 1, minWidth: '100%',
                                                                backgroundColor:
                                                                    parametro.importScopus
                                                                        ? COLOR_RESALTAR
                                                                        : '#FFFFFF',
                                                            }}
                                                            type="text"
                                                            values={values.urlRevista}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.urlRevista && touched.urlRevista)}
                                                            helperText={<ErrorMessage name='urlRevista' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'impactoSJR') && (
                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <strong>Scimago Journal Ranking:</strong>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'impactoSJR') && (
                                                <Grid item xs={12} sm={6} md={4} lg={2}>
                                                    <Tooltip title={FormGlosaryHandle('impactoSJR', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('impactoSJR', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="impactoSJR"
                                                            label={FormLabelHandle(values.tipo, 'impactoSJR')}
                                                            variant="outlined"
                                                            sx={{ m: 1, minWidth: '100%' }}
                                                            type="text"
                                                            values={values.impactoSJR}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.impactoSJR && touched.impactoSJR)}
                                                            helperText={<ErrorMessage name='impactoSJR' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'cuartil') && (
                                                <Grid item xs={12} sm={6} md={4} lg={2}>
                                                    <Tooltip title={FormGlosaryHandle('cuartil', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('cuartil', values.tipo).length === 0}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.cuartil && touched.cuartil)} >
                                                            <InputLabel htmlFor="cuartil">{FormLabelHandle(values.tipo, 'cuartil')}</InputLabel>
                                                            <Select
                                                                labelId="select-cuartil"
                                                                name="cuartil"
                                                                value={values.cuartil}
                                                                label={FormLabelHandle(values.tipo, 'cuartil')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                {quartil.map((q) => (
                                                                    <MenuItem key={q.value} value={q.value}>
                                                                        {q.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='cuartil' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'impactoIndex') && (
                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <strong>CiteScore:</strong>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'impactoIndex') && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={4} lg={2}>
                                                        <Tooltip title={FormGlosaryHandle('impactoIndex', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('impactoIndex', values.tipo).length === 0}>
                                                            <Field
                                                                as={TextField}
                                                                name="impactoIndex"
                                                                label={FormLabelHandle(values.tipo, 'impactoIndex')}
                                                                variant="outlined"
                                                                sx={{ m: 1, minWidth: '100%' }}
                                                                type="text"
                                                                values={values.impactoIndex}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={Boolean(errors.impactoIndex && touched.impactoIndex)}
                                                                helperText={<ErrorMessage name='impactoIndex' />}
                                                            />
                                                        </Tooltip>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4} lg={2}>
                                                        <Tooltip title={FormGlosaryHandle('cuartilCiteScore', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('cuartilCiteScore', values.tipo).length === 0}>
                                                            <FormControl sx={{
                                                                m: 1, backgroundColor:
                                                                    parametro.importScopus
                                                                        ? COLOR_RESALTAR
                                                                        : '#FFFFFF'
                                                            }} fullWidth error={Boolean(errors.cuartil && touched.cuartil)} >
                                                                <InputLabel htmlFor="cuartilCiteScore">{FormLabelHandle(values.tipo, 'cuartilCiteScore')}</InputLabel>
                                                                <Select
                                                                    labelId="select-cuartilCiteScore"
                                                                    name="cuartilCiteScore"
                                                                    value={values.cuartilCiteScore}
                                                                    label={FormLabelHandle(values.tipo, 'cuartilCiteScore')}
                                                                    onChange={async (e: SelectChangeEvent<string>) => {
                                                                        setFieldValue('esPrimerDecilCiteScore', 'N')
                                                                        handleChange(e);
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                >
                                                                    {quartil.map((q) => (
                                                                        <MenuItem key={q.value} value={q.value}>
                                                                            {q.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                                <ErrorMessage name='cuartilCiteScore' className='errorMessage' component="div" />
                                                            </FormControl>
                                                        </Tooltip>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4} lg={2}>
                                                        <Tooltip title={FormGlosaryHandle('esPrimerDecilCiteScore', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('esPrimerDecilCiteScore', values.tipo).length === 0}>
                                                            <FormControl sx={{
                                                                m: 1, backgroundColor:
                                                                    parametro.importScopus
                                                                        ? COLOR_RESALTAR
                                                                        : '#FFFFFF'
                                                            }} fullWidth error={Boolean(errors.revisionpares && touched.revisionpares)} >
                                                                <InputLabel htmlFor="esPrimerDecilCiteScore">{FormLabelHandle(values.tipo, 'esPrimerDecilCiteScore')}</InputLabel>
                                                                <Select
                                                                    labelId="select-esPrimerDecilCiteScore"
                                                                    name="esPrimerDecilCiteScore"
                                                                    value={values.esPrimerDecilCiteScore}
                                                                    label={FormLabelHandle(values.tipo, 'esPrimerDecilCiteScore')}
                                                                    onChange={async (e: SelectChangeEvent<string>) => {
                                                                        const selectedValue = e.target.value as string;
                                                                        try {
                                                                            if (selectedValue === 'S') {
                                                                                setFieldValue('cuartilCiteScore', 'Q1')
                                                                            } else {
                                                                                setFieldValue('cuartilCiteScore', 'Q2')
                                                                            }
                                                                            handleChange(e);
                                                                        } catch (error) {
                                                                            // Maneja el error aquí si es necesario
                                                                        }
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                >
                                                                    {values.cuartilCiteScore === 'Q1' ?
                                                                        desicion.map((q) => (
                                                                            <MenuItem key={q.value} value={q.value}>
                                                                                {q.label}
                                                                            </MenuItem>
                                                                        ))
                                                                        :
                                                                        desicion.filter(x => x.value == 'N').map((q) => (
                                                                            <MenuItem key={q.value} value={q.value}>
                                                                                {q.label}
                                                                            </MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>
                                                                <ErrorMessage name='esPrimerDecilCiteScore' className='errorMessage' component="div" />
                                                            </FormControl>
                                                        </Tooltip>
                                                    </Grid>
                                                </>
                                            )}
                                            {FormTypeHandle(values.tipo, 'editorial') && (
                                                <Grid item xs={12} sm={12} md={9} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('editorial', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('editorial', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="editorial"
                                                            label={FormLabelHandle(values.tipo, 'editorial')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.editorial}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.editorial && touched.editorial)}
                                                            helperText={<ErrorMessage name='editorial' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'idprograma') && (
                                                <Grid item xs={12} sm={12} md={5} lg={5}>
                                                    <Tooltip title={FormGlosaryHandle('idprograma', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('idprograma', values.tipo).length === 0}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.idprograma && touched.idprograma)} >
                                                            <InputLabel htmlFor="idprograma">{FormLabelHandle(values.tipo, 'idprograma')}</InputLabel>
                                                            <Select
                                                                labelId="select-idprograma"
                                                                name="idprograma"
                                                                value={values.idprograma}
                                                                label={FormLabelHandle(values.tipo, 'idprograma')}
                                                                onChange={async (e: SelectChangeEvent<number>) => {
                                                                    const selectedValue = e.target.value as number;
                                                                    try {
                                                                        if (values.espol) {
                                                                            setFieldValue('nombreprograma', listProgramas.find(x => x.value === selectedValue)?.label)
                                                                            setFieldValue('instituciontitularPG', 'ESPOL')
                                                                        } else {
                                                                            setFieldValue('nombreprograma', '')
                                                                            setFieldValue('instituciontitularPG', '')
                                                                        }
                                                                        handleChange(e);
                                                                    } catch (error) {
                                                                        // Maneja el error aquí si es necesario
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                            >
                                                                {listProgramas.map((tipo) => (
                                                                    <MenuItem key={tipo.value} value={tipo.value}>
                                                                        {tipo.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='idprograma' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'programaPostgrado') && (
                                                <>
                                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                                        <>
                                                            <FormControlLabel
                                                                sx={{ m: 1 }}
                                                                label={'¿Es Programa ESPOL?'}
                                                                control={
                                                                    <Checkbox
                                                                        checked={values.espol}
                                                                        name="espol"
                                                                        onChange={async (e: ChangeEvent<{ name?: string; checked: boolean }>) => {
                                                                            const { name, checked } = e.target;
                                                                            try {
                                                                                handleChange(e);
                                                                                if (checked) {
                                                                                    setFieldValue('instituciontitularPG', 'ESPOL')
                                                                                } else {
                                                                                    setFieldValue('idprograma', 0)
                                                                                    // setFieldValue('nombreprograma', '')
                                                                                    // setFieldValue('instituciontitularPG', '')
                                                                                }
                                                                            } catch (error) {
                                                                                // Maneja el error aquí si es necesario
                                                                            }
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                }
                                                            />
                                                            <ErrorMessage name='espol' className='errorMessage' component="div" />
                                                        </>
                                                    </Grid>
                                                    {values.espol ?
                                                        <Grid item xs={12} sm={12} md={5} lg={5}>
                                                            <Tooltip title={FormGlosaryHandle('idprograma', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('idprograma', values.tipo).length === 0}>
                                                                <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.idprograma && touched.idprograma)} >
                                                                    <InputLabel htmlFor="idprograma">{FormLabelHandle(values.tipo, 'idprograma')}</InputLabel>
                                                                    <Select
                                                                        labelId="select-idprograma"
                                                                        name="idprograma"
                                                                        value={values.idprograma}
                                                                        label={FormLabelHandle(values.tipo, 'idprograma')}
                                                                        onChange={async (e: SelectChangeEvent<number>) => {
                                                                            const selectedValue = e.target.value as number;
                                                                            try {
                                                                                if (values.espol) {
                                                                                    setFieldValue('nombreprograma', listProgramas.find(x => x.value === selectedValue)?.label)
                                                                                    setFieldValue('instituciontitularPG', 'ESPOL')
                                                                                } else {
                                                                                    setFieldValue('nombreprograma', '')
                                                                                    setFieldValue('instituciontitularPG', '')
                                                                                }
                                                                                handleChange(e);
                                                                            } catch (error) {
                                                                                // Maneja el error aquí si es necesario
                                                                            }
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    >
                                                                        {listProgramas.map((tipo) => (
                                                                            <MenuItem key={tipo.value} value={tipo.value}>
                                                                                {tipo.label}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                    <ErrorMessage name='idprograma' className='errorMessage' component="div" />
                                                                </FormControl>
                                                            </Tooltip>
                                                        </Grid>
                                                        :
                                                        <Grid item xs={12} sm={12} md={5} lg={5}>
                                                            <Tooltip title={FormGlosaryHandle('nombreprograma', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('nombreprograma', values.tipo).length === 0}>
                                                                <Field
                                                                    as={TextField}
                                                                    name="nombreprograma"
                                                                    label={FormLabelHandle(values.tipo, 'nombreprograma')}
                                                                    variant="outlined"
                                                                    sx={{ m: 1, width: '100%' }}
                                                                    type="text"
                                                                    values={values.nombreprograma}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    error={Boolean(errors.nombreprograma && touched.nombreprograma)}
                                                                    helperText={<ErrorMessage name='nombreprograma' />}
                                                                />
                                                            </Tooltip>
                                                        </Grid>
                                                    }
                                                    <Grid item xs={12} sm={12} md={5} lg={5}>
                                                        <Tooltip title={FormGlosaryHandle('instituciontitularPG', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('instituciontitularPG', values.tipo).length === 0}>
                                                            <Field
                                                                as={TextField}
                                                                name="instituciontitularPG"
                                                                label={FormLabelHandle(values.tipo, 'instituciontitularPG')}
                                                                variant="outlined"
                                                                sx={{ m: 1, width: '100%' }}
                                                                type="text"
                                                                values={values.instituciontitularPG}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                error={Boolean(errors.instituciontitularPG && touched.instituciontitularPG)}
                                                                helperText={<ErrorMessage name='instituciontitularPG' />}
                                                            />
                                                        </Tooltip>
                                                    </Grid>
                                                </>
                                            )}
                                            {(FormTypeHandle(values.tipo, 'palabrasClave') || FormSubClassHandle(values.subclase, 'palabrasClave')) && (
                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <Tooltip title={FormGlosaryHandle('palabrasClave', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('palabrasClave', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="palabrasClave"
                                                            label={FormLabelHandle(values.tipo, 'palabrasClave')}
                                                            variant="outlined"
                                                            sx={{
                                                                m: 1, width: '100%',
                                                                backgroundColor:
                                                                    parametro.importScopus
                                                                        ? COLOR_RESALTAR
                                                                        : '#FFFFFF',
                                                            }}
                                                            type="text"
                                                            values={values.palabrasClave}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.palabrasClave && touched.palabrasClave)}
                                                            helperText={<ErrorMessage name='palabrasClave' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'isindex') && (
                                                <Grid item xs={12} sm={12} md={12} lg={3}>
                                                    <Tooltip title={FormGlosaryHandle('isindex', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('isindex', values.tipo).length === 0}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.isindex && touched.isindex)} >
                                                            <InputLabel htmlFor="isindex">{FormLabelHandle(values.tipo, 'isindex')}</InputLabel>
                                                            <Select
                                                                labelId="select-isindex"
                                                                name="isindex"
                                                                value={values.isindex}
                                                                label={FormLabelHandle(values.tipo, 'isindex')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                {desicionNum.map((d) => (
                                                                    <MenuItem key={d.id} value={d.id}>
                                                                        {d.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='isindex' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'areaimplementacion') && (
                                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('areaimplementacion', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('areaimplementacion', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="areaimplementacion"
                                                            label={FormLabelHandle(values.tipo, 'areaimplementacion')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.areaimplementacion}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.areaimplementacion && touched.areaimplementacion)}
                                                            helperText={<ErrorMessage name='areaimplementacion' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'codigoproducto') && (
                                                <Grid item xs={12} sm={12} md={12} lg={3}>
                                                    <Tooltip title={FormGlosaryHandle('codigoproducto', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('codigoproducto', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="codigoproducto"
                                                            label={FormLabelHandle(values.tipo, 'codigoproducto')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.codigoproducto}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.codigoproducto && touched.codigoproducto)}
                                                            helperText={<ErrorMessage name='codigoproducto' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {(FormTypeHandle(values.tipo, 'asistObjetiv') || FormSubClassHandle(values.subclase, 'asistObjetiv')) && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('asistObjetiv', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('asistObjetiv', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="asistObjetiv"
                                                            label={FormLabelHandle(values.tipo, 'asistObjetiv') + FormSubclaseLabelHandle(values.subclase, 'asistObjetiv')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            multiline
                                                            rows={3}
                                                            values={values.asistObjetiv}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.asistObjetiv && touched.asistObjetiv)}
                                                            helperText={<ErrorMessage name='asistObjetiv' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {(FormTypeHandle(values.tipo, 'innovaVerific') || FormSubClassHandle(values.subclase, 'innovaVerific')) && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('innovaVerific', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('innovaVerific', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="innovaVerific"
                                                            label={FormLabelHandle(values.tipo, 'innovaVerific') + FormSubclaseLabelHandle(values.subclase, 'innovaVerific')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            multiline
                                                            rows={3}
                                                            values={values.innovaVerific}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.innovaVerific && touched.innovaVerific)}
                                                            helperText={<ErrorMessage name='innovaVerific' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {(FormTypeHandle(values.tipo, 'logrosSistemac') || FormSubClassHandle(values.subclase, 'logrosSistemac')) && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('logrosSistemac', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('logrosSistemac', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="logrosSistemac"
                                                            label={FormLabelHandle(values.tipo, 'logrosSistemac') + FormSubclaseLabelHandle(values.subclase, 'logrosSistemac')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            multiline
                                                            rows={3}
                                                            values={values.logrosSistemac}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.logrosSistemac && touched.logrosSistemac)}
                                                            helperText={<ErrorMessage name='logrosSistemac' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {(FormTypeHandle(values.tipo, 'retosComunic') || FormSubClassHandle(values.subclase, 'retosComunic')) && (
                                                <Grid item xs={12} sm={6} md={6} lg={6}>
                                                    <Tooltip title={FormGlosaryHandle('retosComunic', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('retosComunic', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="retosComunic"
                                                            label={FormLabelHandle(values.tipo, 'retosComunic') + FormSubclaseLabelHandle(values.subclase, 'retosComunic')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            multiline
                                                            rows={3}
                                                            values={values.retosComunic}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.retosComunic && touched.retosComunic)}
                                                            helperText={<ErrorMessage name='retosComunic' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {(FormTypeHandle(values.tipo, 'objGeneral') || FormSubClassHandle(values.subclase, 'objGeneral')) && (
                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <Tooltip title={FormGlosaryHandle('objGeneral', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('objGeneral', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="objGeneral"
                                                            label={FormLabelHandle(values.tipo, 'objGeneral')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            multiline
                                                            rows={3}
                                                            values={values.objGeneral}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.objGeneral && touched.objGeneral)}
                                                            helperText={<ErrorMessage name='objGeneral' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'objEspecificos') && (
                                                <Grid container spacing={2} sx={{ m: 1 }}>
                                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                                        <CardUI>
                                                            <CardContent>
                                                                <Grid style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <Typography gutterBottom variant="h5" component="div">
                                                                        {FormLabelHandle(values.tipo, 'objEspecificos')}
                                                                    </Typography>
                                                                    <IconButton aria-label="ver" color="info" onClick={() => handleAddRowEspecificos(values, setFieldValue)}>
                                                                        <FaPlusCircle />
                                                                    </IconButton>
                                                                </Grid>
                                                                <Table>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>#</TableCell>
                                                                            <TableCell>Objetivo</TableCell>
                                                                            <TableCell>Acciones</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {values.objEspecificos.map((especifico, index) => (
                                                                            <TableRow key={'esp-' + especifico.iddecinvproductoobjespecifico}>
                                                                                <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                                                <TableCell>
                                                                                    <FormControl fullWidth >
                                                                                        <Field
                                                                                            as={TextField}
                                                                                            name={`objEspecificos[${index}].objetivo`}
                                                                                            onChange={handleChange}
                                                                                            value={especifico.objetivo}
                                                                                            onBlur={handleBlur}
                                                                                        />
                                                                                        <ErrorMessage name={`objEspecificos[${index}].objetivo`} className='errorMessage' component="div">
                                                                                            {(error) => (
                                                                                                <Alert severity="error">
                                                                                                    {error}
                                                                                                </Alert>
                                                                                            )}
                                                                                        </ErrorMessage>
                                                                                    </FormControl>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <IconButton aria-label="Eliminar" color='error' onClick={() => handleRemoveRowEspecifico(index, values, setFieldValue)}>
                                                                                        <AiFillDelete />
                                                                                    </IconButton>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                                <ErrorMessage name='objEspecificos' className='errorMessage' component="div">
                                                                    {(error) => (
                                                                        <>
                                                                            {errors.objEspecificos && touched.objEspecificos && typeof errors.objEspecificos === 'string' && (
                                                                                <Alert severity="error">
                                                                                    <div>{errors.objEspecificos}</div>
                                                                                </Alert>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </ErrorMessage>
                                                            </CardContent>
                                                        </CardUI>
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'resultados') && (
                                                <Grid container spacing={2} sx={{ m: 1 }}>
                                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                                        <CardUI>
                                                            <CardContent>
                                                                <Grid style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <Typography gutterBottom variant="h5" component="div">
                                                                        {FormLabelHandle(values.tipo, 'resultados')}
                                                                    </Typography>
                                                                    <IconButton aria-label="ver" color="info" onClick={() => handleAddRowResultado(values, setFieldValue)}>
                                                                        <FaPlusCircle />
                                                                    </IconButton>
                                                                </Grid>
                                                                <Table>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>#</TableCell>
                                                                            <TableCell>Resultado</TableCell>
                                                                            <TableCell>Acciones</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {values.resultados.map((especifico, index) => (
                                                                            <TableRow key={'esp-' + especifico.iddecinvproductoresultado}>
                                                                                <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                                                <TableCell>
                                                                                    <FormControl
                                                                                        fullWidth
                                                                                    >
                                                                                        <TextField
                                                                                            name={`resultados[${index}].resultado`}
                                                                                            type="text"
                                                                                            placeholder="Agregar..."
                                                                                            value={especifico.resultado}
                                                                                            onChange={handleChange}
                                                                                            onBlur={handleBlur}
                                                                                        />
                                                                                        <ErrorMessage name={`resultados[${index}].resultado`} className='errorMessage' component="div">
                                                                                            {(error) => (
                                                                                                <Alert severity="error">
                                                                                                    {error}
                                                                                                </Alert>
                                                                                            )}
                                                                                        </ErrorMessage>
                                                                                    </FormControl>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <IconButton aria-label="Eliminar" color='error' onClick={() => handleRemoveRowResultado(index, values, setFieldValue)}>
                                                                                        <AiFillDelete />
                                                                                    </IconButton>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                                <ErrorMessage name='resultados' className='errorMessage' component="div">
                                                                    {(error) => (
                                                                        <>
                                                                            {errors.resultados && touched.resultados && typeof errors.resultados === 'string' && (
                                                                                <Alert severity="error">
                                                                                    <div>{errors.resultados}</div>
                                                                                </Alert>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </ErrorMessage>
                                                            </CardContent>
                                                        </CardUI>
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {(FormTypeHandle(values.tipo, 'especificacion') || FormSubClassHandle(values.subclase, 'especificacion')) && (
                                                <Grid item xs={12} sm={12} md={12} lg={9}>
                                                    <Tooltip title={FormGlosaryHandle('especificacion', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('especificacion', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="especificacion"
                                                            label={FormLabelHandle(values.tipo, 'especificacion')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            multiline
                                                            maxLength={30}
                                                            rows={3}
                                                            values={values.especificacion}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.especificacion && touched.especificacion)}
                                                            helperText={<ErrorMessage name='especificacion' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {(FormTypeHandle(values.tipo, 'resumen') || FormSubClassHandle(values.subclase, 'resumen')) && (
                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <Tooltip title={FormGlosaryHandle('resumen', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('resumen', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="resumen"
                                                            label={FormLabelHandle(values.tipo, 'resumen')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            multiline
                                                            maxLength={3000}
                                                            rows={3}
                                                            values={values.resumen}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.resumen && touched.resumen)}
                                                            helperText={<ErrorMessage name='resumen' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                        </Grid>
                                        <Grid container spacing={2}>
                                            {FormTypeHandle(values.tipo, 'codarea') && (
                                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                                    <Tooltip title={FormGlosaryHandle('codarea', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('codarea', values.tipo).length === 0}>
                                                        <FormControl sx={{
                                                            m: 1, backgroundColor:
                                                                parametro.importScopus
                                                                    ? COLOR_RESALTAR
                                                                    : '#FFFFFF', // blanco por defecto 
                                                        }} fullWidth error={Boolean(errors.codarea && touched.codarea)} >
                                                            <InputLabel htmlFor="codarea">{FormLabelHandle(values.tipo, 'codarea')}</InputLabel>
                                                            <Select
                                                                labelId="select-codarea"
                                                                name="codarea"
                                                                value={values.codarea}
                                                                label={FormLabelHandle(values.tipo, 'codarea')}
                                                                onChange={async (e: SelectChangeEvent<number>) => {
                                                                    const selectedValue = e.target.value as number;
                                                                    // Llama a tu función externa para obtener datos de la API
                                                                    try {
                                                                        const apiData = await setListSubaArea(selectedValue);
                                                                        setSubAreasCineDet([]);
                                                                        setFieldValue('codsubareadetallada', 0)
                                                                        handleChange(e);
                                                                    } catch (error) {
                                                                        // Maneja el error aquí si es necesario
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                            >
                                                                <MenuItem key={'null-codarea'} value={0}>
                                                                    {'NINGUNO'}
                                                                </MenuItem>
                                                                {loadedAreasCine ?
                                                                    (areasCine.map((ods) => (
                                                                        <MenuItem
                                                                            key={ods.codigo}
                                                                            value={ods.codigo}
                                                                        >
                                                                            {ods.descripcion}
                                                                        </MenuItem>
                                                                    )))
                                                                    :
                                                                    <MenuItem disabled>
                                                                        <CircularProgress size={24} />
                                                                    </MenuItem>
                                                                }
                                                            </Select>
                                                            <ErrorMessage name='codarea' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'codsubarea') && (
                                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                                    <Tooltip title={FormGlosaryHandle('codsubarea', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('codsubarea', values.tipo).length === 0}>
                                                        <FormControl sx={{
                                                            m: 1, backgroundColor:
                                                                parametro.importScopus
                                                                    ? COLOR_RESALTAR
                                                                    : '#FFFFFF'
                                                        }} fullWidth error={Boolean(errors.codsubarea && touched.codsubarea)} >
                                                            <InputLabel htmlFor="codsubarea">{FormLabelHandle(values.tipo, 'codsubarea')}</InputLabel>
                                                            <Select
                                                                labelId="select-codsubarea"
                                                                name="codsubarea"
                                                                value={values.codsubarea}
                                                                label={FormLabelHandle(values.tipo, 'codsubarea')}
                                                                onChange={async (e: SelectChangeEvent<number>) => {
                                                                    const selectedValue = e.target.value as number;
                                                                    // Llama a tu función externa para obtener datos de la API
                                                                    try {
                                                                        const apiData = await setListSubaAreaDet(selectedValue);
                                                                        handleChange(e);
                                                                    } catch (error) {
                                                                        // Maneja el error aquí si es necesario
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                            >
                                                                <MenuItem key={'null-codsubarea'} value={0}>
                                                                    {'NINGUNO'}
                                                                </MenuItem>
                                                                {loadedSubAreasCine ?
                                                                    (subAreasCine.map((ods) => (
                                                                        <MenuItem
                                                                            key={ods.codigo}
                                                                            value={ods.codigo}
                                                                        >
                                                                            {ods.descripcion}
                                                                        </MenuItem>
                                                                    )))
                                                                    :
                                                                    <MenuItem disabled>
                                                                        <CircularProgress size={24} />
                                                                    </MenuItem>
                                                                }
                                                            </Select>
                                                            <ErrorMessage name='codsubarea' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'codsubareadetallada') && (
                                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                                    <Tooltip title={FormGlosaryHandle('codsubareadetallada', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('codsubareadetallada', values.tipo).length === 0}>
                                                        <FormControl sx={{
                                                            m: 1, backgroundColor:
                                                                parametro.importScopus
                                                                    ? COLOR_RESALTAR
                                                                    : '#FFFFFF'
                                                        }} fullWidth error={Boolean(errors.codsubareadetallada && touched.codsubareadetallada)} >
                                                            <InputLabel htmlFor="codsubareadetallada">{FormLabelHandle(values.tipo, 'codsubareadetallada')}</InputLabel>
                                                            <Select
                                                                labelId="select-codsubareadetallada"
                                                                name="codsubareadetallada"
                                                                value={values.codsubareadetallada}
                                                                label={FormLabelHandle(values.tipo, 'codsubareadetallada')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                <MenuItem key={'null-codsubareadetellada'} value={0}>
                                                                    {'NINGUNO'}
                                                                </MenuItem>
                                                                {loadedSubAreasCineDet ?
                                                                    (subAreasCineDet.map((ods) => (
                                                                        <MenuItem
                                                                            key={ods.codigo}
                                                                            value={ods.codigo}
                                                                        >
                                                                            {ods.descripcion}
                                                                        </MenuItem>
                                                                    ))) :
                                                                    <MenuItem disabled>
                                                                        <CircularProgress size={24} />
                                                                    </MenuItem>}
                                                            </Select>
                                                            <ErrorMessage name='codsubareadetallada' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                        </Grid>
                                        <Grid container sx={{ mt: 1 }} spacing={2}>
                                            {FormTypeHandle(values.tipo, 'iddecinvareaconocimiento') && (
                                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                                    <Tooltip title={FormGlosaryHandle('iddecinvareaconocimiento', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('iddecinvareaconocimiento', values.tipo).length === 0}>
                                                        <FormControl sx={{
                                                            m: 1, backgroundColor:
                                                                parametro.importScopus
                                                                    ? COLOR_RESALTAR
                                                                    : '#FFFFFF'
                                                        }} fullWidth error={Boolean(errors.iddecinvareaconocimiento && touched.iddecinvareaconocimiento)} >
                                                            <InputLabel htmlFor="iddecinvareaconocimiento">{FormLabelHandle(values.tipo, 'iddecinvareaconocimiento')}</InputLabel>
                                                            <Select
                                                                labelId="select-iddecinvareaconocimiento"
                                                                name="iddecinvareaconocimiento"
                                                                value={values.iddecinvareaconocimiento}
                                                                label={FormLabelHandle(values.tipo, 'iddecinvareaconocimiento')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                <MenuItem key={'null-ODS'} value={0}>
                                                                    {'SELECCIONE ÁREA'}
                                                                </MenuItem>
                                                                {areasLineasInvestigacion.map((area) => (
                                                                    <MenuItem
                                                                        key={area.codigo}
                                                                        value={area.codigo}
                                                                    >
                                                                        {area.descripcion}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='iddecinvareaconocimiento' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'lineainvestigacion') && (
                                                <Grid item xs={12} sm={6} md={4} lg={4}>
                                                    <Tooltip title={FormGlosaryHandle('lineainvestigacion', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('lineainvestigacion', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="lineainvestigacion"
                                                            label={FormLabelHandle(values.tipo, 'lineainvestigacion')}
                                                            variant="outlined"
                                                            sx={{
                                                                m: 1, width: '100%', backgroundColor:
                                                                    parametro.importScopus
                                                                        ? COLOR_RESALTAR
                                                                        : '#FFFFFF'
                                                            }}
                                                            type="text"
                                                            values={values.lineainvestigacion}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.lineainvestigacion && touched.lineainvestigacion)}
                                                            helperText={<ErrorMessage name='lineainvestigacion' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'iddecinvobjods') && (
                                                <Tooltip title={FormGlosaryHandle('iddecinvobjods', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('iddecinvobjods', values.tipo).length === 0}>
                                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.iddecinvobjods && touched.iddecinvobjods)} >
                                                            <InputLabel id="select-iddecinvobjods">{FormLabelHandle(values.tipo, 'iddecinvobjods')}</InputLabel>
                                                            <Select
                                                                labelId="select-iddecinvobjods"
                                                                name="iddecinvobjods"
                                                                value={values.iddecinvobjods}
                                                                label={FormLabelHandle(values.tipo, 'iddecinvobjods')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            >
                                                                <MenuItem key={'null-ODS'} value={0}>
                                                                    {'SELECCIONE ODS'}
                                                                </MenuItem>
                                                                {listODS.map((ods) => (
                                                                    <MenuItem
                                                                        key={ods.codigo}
                                                                        value={ods.codigo}
                                                                    >
                                                                        {ods.descripcion}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name='iddecinvobjods' className='errorMessage' component="div" />
                                                        </FormControl>
                                                    </Grid>
                                                </Tooltip>
                                            )}
                                            {FormTypeHandle(values.tipo, 'casillaMateriaInt') && (
                                                <Tooltip title={FormGlosaryHandle('casillaMateriaInt', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('casillaMateriaInt', values.tipo).length === 0}>
                                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                                        {/* <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.casillaMateriaInt && touched.casillaMateriaInt)} >
                <InputLabel htmlFor="casillaMateriaInt">{FormLabelHandle(values.tipo,'casillaMateriaInt')}</InputLabel> */}
                                                        <>
                                                            <FormControlLabel
                                                                sx={{ m: 1 }}
                                                                label={FormLabelHandle(values.tipo, 'casillaMateriaInt')}
                                                                control={
                                                                    <Checkbox
                                                                        name="casillaMateriaInt"
                                                                        checked={values.casillaMateriaInt}
                                                                        onChange={handleChange}
                                                                    />
                                                                }
                                                            />
                                                            <ErrorMessage name='casillaMateriaInt' className='errorMessage' component="div" />
                                                        </>
                                                        {/* </FormControl> */}
                                                    </Grid>
                                                </Tooltip>
                                            )}
                                            {FormTypeHandle(values.tipo, 'casillaPais') && (
                                                <Tooltip title={FormGlosaryHandle('casillaPais', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('casillaPais', values.tipo).length === 0}>
                                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                                        <>
                                                            <FormControlLabel
                                                                sx={{ m: 1 }}
                                                                label={FormLabelHandle(values.tipo, 'casillaPais')}
                                                                control={
                                                                    <Checkbox
                                                                        name="casillaPais"
                                                                        checked={values.casillaPais}
                                                                        onChange={async (e: ChangeEvent<{ name?: string; checked: boolean }>) => {
                                                                            const { name, checked } = e.target;
                                                                            try {
                                                                                if (!checked) {
                                                                                    setFieldValue('idpais', 1816)
                                                                                }
                                                                                handleChange(e);
                                                                            } catch (error) {
                                                                                // Maneja el error aquí si es necesario
                                                                            }
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                }
                                                            />
                                                            <ErrorMessage name='casillaPais' className='errorMessage' component="div" />
                                                        </>
                                                        {/* </FormControl> */}
                                                    </Grid>
                                                </Tooltip>
                                            )}
                                            {FormTypeHandle(values.tipo, 'idpais') && (
                                                <Tooltip title={FormGlosaryHandle('idpais', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('idpais', values.tipo).length === 0}>
                                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                                        <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.idpais && touched.idpais)}>
                                                            <InputLabel id="select-pais">{FormLabelHandle(values.tipo, 'idpais')}</InputLabel>
                                                            <Select
                                                                labelId="select-pais"
                                                                name="idpais"
                                                                value={values.idpais}
                                                                label={FormLabelHandle(values.tipo, 'idpais')}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                disabled={!values.casillaPais}
                                                            >
                                                                <MenuItem key={'null-idpais'} value={0}>
                                                                    {'SELECCIONE PAIS'}
                                                                </MenuItem>
                                                                {paises.map((est) => (
                                                                    <MenuItem key={est.codigo} value={est.codigo}>{est.descripcion}</MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Tooltip>
                                            )}
                                            {FormTypeHandle(values.tipo, 'instTitular') && (
                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <Tooltip title={FormGlosaryHandle('instTitular', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('instTitular', values.tipo).length === 0}>
                                                        <Field
                                                            as={TextField}
                                                            name="instTitular"
                                                            label={FormLabelHandle(values.tipo, 'instTitular')}
                                                            variant="outlined"
                                                            sx={{ m: 1, width: '100%' }}
                                                            type="text"
                                                            values={values.instTitular}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            error={Boolean(errors.instTitular && touched.instTitular)}
                                                            helperText={<ErrorMessage name='instTitular' />}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                        </Grid>
                                        <Grid container sx={{ mt: 1 }} spacing={2}>
                                            {FormTypeHandle(values.tipo, 'solicitantes') && (
                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                    <CardUI>
                                                        <CardHeader>
                                                            <div>
                                                                <Tooltip title={FormGlosaryHandle('solicitantes', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('solicitantes', values.tipo).length === 0}>
                                                                    <InputLabel >{FormLabelHandle(values.tipo, 'solicitantes')}<BsInfoSquare /></InputLabel>
                                                                </Tooltip>
                                                            </div>
                                                        </CardHeader>
                                                        <CardContent>
                                                            <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.solicitantes && touched.solicitantes)} >
                                                                <Table>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell>#</TableCell>
                                                                            <TableCell>Titulo</TableCell>
                                                                            {!noUsoTitularidad(values.tipo) ? <TableCell>% Titularidad</TableCell> : <></>}
                                                                            <TableCell>Acción</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {values.solicitantes.map((sol: ProductoTerminSolicitanteDTO, index) => (
                                                                            <TableRow key={'solProduct-' + index}>
                                                                                <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                                                <TableCell>
                                                                                    <FormControl fullWidth >
                                                                                        <Field
                                                                                            as={TextField}
                                                                                            name={`solicitantes[${index}].nombre`}
                                                                                            onChange={handleChange}
                                                                                            value={sol.nombre}
                                                                                            onBlur={handleBlur}
                                                                                        />
                                                                                        <ErrorMessage name={`solicitantes[${index}].nombre`} className='errorMessage' component="div">
                                                                                            {(error) => (
                                                                                                <Alert severity="error">
                                                                                                    {error}
                                                                                                </Alert>
                                                                                            )}
                                                                                        </ErrorMessage>
                                                                                    </FormControl>
                                                                                </TableCell>
                                                                                {!noUsoTitularidad(values.tipo) ?
                                                                                    <TableCell>
                                                                                        <FormControl
                                                                                            fullWidth
                                                                                        >
                                                                                            <TextField
                                                                                                name={`solicitantes[${index}].porcentajetitularidad`}
                                                                                                type="text"
                                                                                                placeholder="0"
                                                                                                value={sol.porcentajetitularidad}
                                                                                                onChange={handleChange}
                                                                                                onBlur={handleBlur}
                                                                                            />
                                                                                            <ErrorMessage name={`solicitantes[${index}].porcentajetitularidad`} className='errorMessage' component="div">
                                                                                                {(error) => (
                                                                                                    <Alert severity="error">
                                                                                                        {error}
                                                                                                    </Alert>
                                                                                                )}
                                                                                            </ErrorMessage>
                                                                                        </FormControl>
                                                                                    </TableCell>
                                                                                    : <></>}
                                                                                <TableCell>
                                                                                    <IconButton aria-label="delete" color="error" onClick={() => handleRemoveRowSolicitante(index, values, setFieldValue)}>
                                                                                        <AiFillDelete />
                                                                                    </IconButton>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                                <ErrorMessage name='solicitantes' className='errorMessage' component="div">
                                                                    {(error) => (
                                                                        <>
                                                                            {errors.solicitantes && touched.solicitantes && typeof errors.solicitantes === 'string' && (
                                                                                <Alert severity="error">
                                                                                    {errors.solicitantes}
                                                                                </Alert>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </ErrorMessage>
                                                            </FormControl>
                                                        </CardContent>
                                                        <CardActions>
                                                            <IconButton aria-label="delete" color="success" onClick={() => handleAddRowSolicitante(values, setFieldValue)}>
                                                                <BiAddToQueue />
                                                            </IconButton>
                                                        </CardActions>
                                                    </CardUI>
                                                </Grid>
                                            )}
                                            {FormTypeHandle(values.tipo, 'proyectorel') && (
                                                <>
                                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                                        <CardUI>
                                                            <CardHeader>
                                                                <div>
                                                                    <Tooltip title={FormGlosaryHandle('proyectorel', values.tipo)} placement="top" arrow disableFocusListener={FormGlosaryHandle('proyectorel', values.tipo).length === 0}>
                                                                        <InputLabel >{FormLabelHandle(values.tipo, 'proyectorel')}<BsInfoSquare /></InputLabel>
                                                                    </Tooltip>
                                                                </div>
                                                            </CardHeader>
                                                            <CardContent>
                                                                <FormControl sx={{ m: 1, width: '100%' }} size='small' error={Boolean(errors.proyectorel && touched.proyectorel)} >
                                                                    <Table>
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell>#</TableCell>
                                                                                <TableCell>Titulo</TableCell>
                                                                                <TableCell>Acción</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {values.proyectorel.map((proy: ProyectoRelacionado, index) => (
                                                                                <TableRow key={'colProy-' + proy.iddecinvproyecto}>
                                                                                    <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                                                    <TableCell>
                                                                                        {proy.tituloProyecto}
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        <IconButton aria-label="delete" color="error" onClick={() => handleRemoveProyectoRel(index, values, setFieldValue)}>
                                                                                            <AiFillDelete />
                                                                                        </IconButton>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                    <ErrorMessage name='proyectorel' className='errorMessage' component="div" />
                                                                </FormControl>
                                                            </CardContent>
                                                            <CardActions>
                                                                <IconButton aria-label="delete" color="success" onClick={handleProyOpen}>
                                                                    <BiAddToQueue />
                                                                </IconButton>
                                                            </CardActions>
                                                        </CardUI>
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                        <br />
                                        {values.tipo > 0 && (
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={12} md={12} lg={12} >
                                                    <CardUI sx={{
                                                        backgroundColor:
                                                            parametro.importScopus
                                                                ? COLOR_RESALTAR
                                                                : '#FFFFFF'
                                                    }}>
                                                        <CardContent>
                                                            <Typography gutterBottom variant="h5" component="div">
                                                                Archivos Adjuntos
                                                            </Typography>
                                                            <Grid container spacing={2}>
                                                                {FormTypeHandle(values.tipo, 'adjunto') &&
                                                                    (<Grid item xs={12} sm={12} md={9} lg={9}>
                                                                        <Tooltip title={FormGlosaryHandle('adjunto', values.tipo)} placement="top-start" disableFocusListener={FormGlosaryHandle('adjunto', values.tipo).length === 0}>
                                                                            <InputLabel htmlFor="adjunto">{FormLabelHandle(values.tipo, 'adjunto') + FormSubclaseLabelHandle(values.subclase, 'adjunto')}</InputLabel></Tooltip>
                                                                        <input
                                                                            type="file"
                                                                            id="adjunto"
                                                                            name="adjunto"
                                                                            accept=".pdf"
                                                                            onChange={async (event) => {
                                                                                if (event.currentTarget.files && event.currentTarget.files[0]) {
                                                                                    const file = event.currentTarget.files[0];
                                                                                    const maxSize = 8 * 1024 * 1024; // Tamaño máximo en bytes (8 MB)

                                                                                    if (file.size <= maxSize) {
                                                                                        var files = values.adjuntos ?? [];
                                                                                        files[0] = await setFileModelWithName(event.currentTarget.files[0], 'adjunto');
                                                                                        setFieldValue('adjuntos', files);
                                                                                        setFieldValue('adjunto', '1');
                                                                                    } else {
                                                                                        alertaService.alertaAdvertencia("Alerta", "El tamaño maximo de los archivos es 8 MB.")
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                        <ErrorMessage name='adjunto' className='errorMessage' component="div" />
                                                                    </Grid>)
                                                                }
                                                                {FormTypeHandle(values.tipo, 'adjunto') && ArchivoHandler(1, datosFormulario.archivosProd).iddecinvproductoarchivo > 0 &&
                                                                    (<Grid item xs={12} sm={12} md={3} lg={3}>
                                                                        <Button aria-label="archivo1" variant="contained"
                                                                            color="error" startIcon={<FaFilePdf />} onClick={() => { OpenArchivo(ArchivoHandler(1, datosFormulario.archivosProd)) }}>
                                                                            Ver
                                                                        </Button>
                                                                    </Grid>)
                                                                }
                                                                {FormTypeHandle(values.tipo, 'adjunto2') && (<Grid item xs={12} sm={12} md={9} lg={9}>
                                                                    <Tooltip title={FormGlosaryHandle('adjunto2', values.tipo)} placement="top-start" disableFocusListener={FormGlosaryHandle('adjunto2', values.tipo).length === 0}>
                                                                        <InputLabel htmlFor="adjunto2">{FormLabelHandle(values.tipo, 'adjunto2') + FormSubclaseLabelHandle(values.subclase, 'adjunto2')}</InputLabel></Tooltip>
                                                                    <input
                                                                        type="file"
                                                                        id="adjunto2"
                                                                        name="adjunto2"
                                                                        accept=".pdf"
                                                                        onChange={async (event) => {
                                                                            if (event.currentTarget.files && event.currentTarget.files[0]) {
                                                                                const file = event.currentTarget.files[0];
                                                                                const maxSize = 8 * 1024 * 1024; // Tamaño máximo en bytes (8 MB)

                                                                                if (file.size <= maxSize) {
                                                                                    var files = values.adjuntos ?? [];
                                                                                    files[1] = await setFileModelWithName(event.currentTarget.files[0], 'adjunto2');
                                                                                    setFieldValue('adjuntos', files);
                                                                                    setFieldValue('adjunto2', '2');
                                                                                } else {
                                                                                    alertaService.alertaAdvertencia("Alerta", "El tamaño maximo de los archivos es 8 MB.")
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                    <ErrorMessage name='adjunto2' className='errorMessage' component="div" />
                                                                </Grid>)}
                                                                {FormTypeHandle(values.tipo, 'adjunto2') && ArchivoHandler(2, datosFormulario.archivosProd).iddecinvproductoarchivo > 0 &&
                                                                    (<Grid item xs={12} sm={12} md={3} lg={3}>
                                                                        <Button aria-label="archivo2" variant="contained"
                                                                            color="error" startIcon={<FaFilePdf />} onClick={() => { OpenArchivo(ArchivoHandler(2, datosFormulario.archivosProd)) }}>
                                                                            Ver
                                                                        </Button>
                                                                    </Grid>)
                                                                }
                                                                {FormTypeHandle(values.tipo, 'adjunto3') && (<Grid item xs={12} sm={12} md={9} lg={9}>
                                                                    <Tooltip title={FormGlosaryHandle('adjunto3', values.tipo)} placement="top-start" disableFocusListener={FormGlosaryHandle('adjunto3', values.tipo).length === 0}>
                                                                        <InputLabel htmlFor="adjunto3">{FormLabelHandle(values.tipo, 'adjunto3') + FormSubclaseLabelHandle(values.subclase, 'adjunto3')}</InputLabel></Tooltip>
                                                                    <input
                                                                        type="file"
                                                                        id="adjunto3"
                                                                        name="adjunto3"
                                                                        accept=".pdf"
                                                                        onChange={async (event) => {
                                                                            if (event.currentTarget.files && event.currentTarget.files[0]) {
                                                                                const file = event.currentTarget.files[0];
                                                                                const maxSize = 8 * 1024 * 1024; // Tamaño máximo en bytes (8 MB)
                                                                                if (file.size <= maxSize) {
                                                                                    var files = values.adjuntos ?? [];
                                                                                    files[2] = await setFileModelWithName(event.currentTarget.files[0], 'adjunto3');
                                                                                    setFieldValue('adjuntos', files);
                                                                                    setFieldValue('adjunto3', '3');
                                                                                } else {
                                                                                    alertaService.alertaAdvertencia("Alerta", "El tamaño maximo de los archivos es 8 MB.")
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                    <ErrorMessage name='adjunto3' className='errorMessage' component="div" />
                                                                </Grid>)}
                                                                {FormTypeHandle(values.tipo, 'adjunto3') && ArchivoHandler(3, datosFormulario.archivosProd).iddecinvproductoarchivo > 0 &&
                                                                    (<Grid item xs={12} sm={12} md={3} lg={3}>
                                                                        <Button aria-label="archivo3" variant="contained"
                                                                            color="error" startIcon={<FaFilePdf />} onClick={() => { OpenArchivo(ArchivoHandler(3, datosFormulario.archivosProd)) }}>
                                                                            Ver
                                                                        </Button>
                                                                    </Grid>)
                                                                }
                                                                {FormTypeHandle(values.tipo, 'adjunto4') && (<Grid item xs={12} sm={12} md={9} lg={9}>
                                                                    <Tooltip title={FormGlosaryHandle('adjunto4', values.tipo)} placement="top-start" disableFocusListener={FormGlosaryHandle('adjunto4', values.tipo).length === 0}>
                                                                        <InputLabel htmlFor="adjunto4">{FormLabelHandle(values.tipo, 'adjunto4') + FormSubclaseLabelHandle(values.subclase, 'adjunto4')}</InputLabel></Tooltip>
                                                                    <input
                                                                        type="file"
                                                                        id="adjunto4"
                                                                        name="adjunto4"
                                                                        accept=".pdf"
                                                                        onChange={async (event) => {
                                                                            if (event.currentTarget.files && event.currentTarget.files[0]) {
                                                                                const file = event.currentTarget.files[0];
                                                                                const maxSize = 8 * 1024 * 1024; // Tamaño máximo en bytes (8 MB)
                                                                                if (file.size <= maxSize) {
                                                                                    var files = values.adjuntos ?? [];
                                                                                    files[3] = await setFileModelWithName(event.currentTarget.files[0], 'adjunto4');
                                                                                    setFieldValue('adjuntos', files);
                                                                                    setFieldValue('adjunto4', '4');
                                                                                } else {
                                                                                    alertaService.alertaAdvertencia("Alerta", "El tamaño maximo de los archivos es 8 MB.")
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                    <ErrorMessage name='adjunto4' className='errorMessage' component="div" />
                                                                </Grid>)}
                                                                {FormTypeHandle(values.tipo, 'adjunto4') && ArchivoHandler(4, datosFormulario.archivosProd).iddecinvproductoarchivo > 0 &&
                                                                    (<Grid item xs={12} sm={12} md={3} lg={3}>
                                                                        <Button aria-label="archivo4" variant="contained"
                                                                            color="error" startIcon={<FaFilePdf />} onClick={() => { OpenArchivo(ArchivoHandler(4, datosFormulario.archivosProd)) }}>
                                                                            Ver
                                                                        </Button>
                                                                    </Grid>)
                                                                }
                                                                {FormTypeHandle(values.tipo, 'adjunto5') && (
                                                                    <Grid item xs={12} sm={12} md={9} lg={9}>
                                                                        <Tooltip title={FormGlosaryHandle('adjunto5', values.tipo)} placement="top-start" disableFocusListener={FormGlosaryHandle('adjunto5', values.tipo).length === 0}>
                                                                            <InputLabel htmlFor="adjunto5">{FormLabelHandle(values.tipo, 'adjunto5') + FormSubclaseLabelHandle(values.subclase, 'adjunto5')}</InputLabel></Tooltip>
                                                                        <input
                                                                            type="file"
                                                                            id="adjunto5"
                                                                            name="adjunto5"
                                                                            accept=".pdf"
                                                                            onChange={async (event) => {
                                                                                if (event.currentTarget.files && event.currentTarget.files[0]) {
                                                                                    const file = event.currentTarget.files[0];
                                                                                    const maxSize = 8 * 1024 * 1024; // Tamaño máximo en bytes (8 MB)
                                                                                    if (file.size <= maxSize) {
                                                                                        var files = values.adjuntos ?? [];
                                                                                        files[4] = await setFileModelWithName(event.currentTarget.files[0], 'adjunto5');
                                                                                        setFieldValue('adjuntos', files);
                                                                                        setFieldValue('adjunto5', '5');
                                                                                    } else {
                                                                                        alertaService.alertaAdvertencia("Alerta", "El tamaño maximo de los archivos es 8 MB.")
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                        <ErrorMessage name='adjunto5' className='errorMessage' component="div" />
                                                                    </Grid>)}
                                                                {FormTypeHandle(values.tipo, 'adjunto5') && ArchivoHandler(5, datosFormulario.archivosProd).iddecinvproductoarchivo > 0 &&
                                                                    (<Grid item xs={12} sm={12} md={3} lg={3} >
                                                                        <Button aria-label="archivo5" variant="contained"
                                                                            color="error" startIcon={<FaFilePdf />} onClick={() => { OpenArchivo(ArchivoHandler(5, datosFormulario.archivosProd)) }}>
                                                                            Ver
                                                                        </Button>
                                                                    </Grid>)
                                                                }
                                                            </Grid>
                                                        </CardContent>
                                                    </CardUI>
                                                </Grid>
                                            </Grid>
                                        )}
                                        <br />
                                    </>
                                )}
                                <br />
                                <Box sx={{ '& .MuiTextField-root': { m: 1 }, }}>
                                    {values.tipo > 0 ?
                                        <Grid className='siempre' container spacing={2}>
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Button
                                                    color="error"
                                                    variant="contained"
                                                    onClick={() => goToNavigation('/Producto/MisProductos')}
                                                    endIcon={<MdAssignmentReturn />} >
                                                    Regresar
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Button
                                                    color='success'
                                                    type='submit'
                                                    variant="contained"
                                                    onClick={() => setModo('G')}
                                                    endIcon={<BsEraserFill />} >
                                                    Borrador
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Button
                                                    type='submit'
                                                    //disabled={!isValid} 
                                                    variant="contained"
                                                    onClick={() => setModo('C')}
                                                    endIcon={<RiSave3Fill />} >
                                                    Guardar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        : <></>}
                                </Box>
                                <ModalStrap isOpen={open} toggle={toggleOpen} className="custom-modal">
                                    <ModalHeader toggle={toggleOpen}>
                                        <Typography id="modal-modal-title" >Colaboradores Proyectos</Typography>
                                    </ModalHeader>
                                    <ModalBody>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>#</TableCell>
                                                    <TableCell>Cedula</TableCell>
                                                    <TableCell>Apellidos y Nombres</TableCell>
                                                    <TableCell>Institucion</TableCell>
                                                    <TableCell>Correo</TableCell>
                                                    <TableCell>Accion</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {colaboradorProyecto.map((colaborador, index) => (
                                                    <TableRow key={'colProy-' + index}>
                                                        <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                        <TableCell>
                                                            {colaborador.cedula}
                                                        </TableCell>
                                                        <TableCell>
                                                            {colaborador.nombre}
                                                        </TableCell>
                                                        <TableCell>
                                                            {colaborador.institucion}
                                                        </TableCell>
                                                        <TableCell>
                                                            {colaborador.email}
                                                        </TableCell>
                                                        <TableCell>
                                                            {isColaboradorSelected(values, colaborador)
                                                                ? <></> :
                                                                <IconButton aria-label="add" color="info" onClick={() => handleAddRowColaborador(values, colaborador, setFieldValue)} >
                                                                    <AiOutlinePlusCircle />
                                                                </IconButton>
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </ModalBody>
                                </ModalStrap>
                                <ModalStrap isOpen={userModal} toggle={toggleModal} className="custom-modal">
                                    <ModalHeader toggle={toggleModal}>
                                        <Typography id="modal-modal-title" >Busqueda Usuario</Typography>
                                    </ModalHeader>
                                    <ModalBody>
                                        <Nav tabs>
                                            <NavItem>
                                                <NavLink className={tap === 0 ? 'active' : ''} style={tabStyle}
                                                    onClick={() => setTap(0)}
                                                >
                                                    Email
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink className={tap === 1 ? 'active' : ''} style={tabStyle}
                                                    onClick={() => setTap(1)}
                                                >
                                                    Apellidos
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <TabContent activeTab={tap}>
                                            <TabPane tabId={0}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12} md={9} lg={9}>
                                                        <TextField
                                                            id='busq-email'
                                                            type="email"
                                                            name='mailBusqueda'
                                                            label="Email"
                                                            sx={{ m: 1, width: '100%' }}
                                                            size="small"
                                                            value={mailBusqueda}
                                                            onChange={handleEmailBusquedaChange}
                                                            onBlur={handleEmailBlur}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={3} lg={3}>
                                                        <Button variant="contained" style={buttonStyle} endIcon={<AiOutlineSearch />} onClick={() => { setListBusqueda('N', mailBusqueda) }}>Buscar</Button>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                                        {loadingModal ?
                                                            <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                                                                <CircularProgress color="success" />
                                                            </Stack> :
                                                            <Table>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>#</TableCell>
                                                                        <TableCell>Cedula</TableCell>
                                                                        <TableCell>Apellidos y Nombres</TableCell>
                                                                        <TableCell>Correo</TableCell>
                                                                        <TableCell>Accion</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {busquedaUsuario.map((colaborador, index) => (
                                                                        <TableRow key={'colProy-' + index}>
                                                                            <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                                            <TableCell>
                                                                                {colaborador.cedula}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {colaborador.nombre}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {colaborador.email}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {isColaboradorSelected(values, colaborador) ?
                                                                                    <></> :
                                                                                    <IconButton aria-label="add" color="info" onClick={() => handleAddRowColaborador(values, colaborador, setFieldValue)} >
                                                                                        <AiOutlinePlusCircle />
                                                                                    </IconButton>}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                    {busquedaUsuario.length == 0 ?
                                                                        <TableRow key={'colProy-o'}>
                                                                            <TableCell></TableCell>
                                                                            <TableCell></TableCell>
                                                                            <TableCell>Sin resultados</TableCell>
                                                                            <TableCell></TableCell>
                                                                            <TableCell></TableCell>
                                                                        </TableRow> : <></>
                                                                    }
                                                                </TableBody>
                                                            </Table>
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </TabPane>
                                            <TabPane tabId={1}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12} md={9} lg={9}>
                                                        <TextField
                                                            id='busq-apellidos'
                                                            label="Apellidos"
                                                            sx={{ m: 1, width: '100%' }}
                                                            size="small"
                                                            value={apellidosBusqueda}
                                                            onChange={handleApellidosBusquedaChange}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={3} lg={3}>
                                                        <Button variant="contained" style={buttonStyle} endIcon={<AiOutlineSearch />} onClick={() => { setListBusqueda(apellidosBusqueda, 'N') }}>Buscar</Button>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                                        {loadingModal ?
                                                            <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                                                                <CircularProgress color="success" />
                                                            </Stack> :
                                                            <Table>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell>#</TableCell>
                                                                        <TableCell>Cedula</TableCell>
                                                                        <TableCell>Apellidos y Nombres</TableCell>
                                                                        <TableCell>Correo</TableCell>
                                                                        <TableCell>Accion</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {busquedaUsuario.map((colaborador, index) => (
                                                                        <TableRow key={'colProy-' + index}>
                                                                            <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                                            <TableCell>
                                                                                {colaborador.cedula}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {colaborador.nombre}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {colaborador.email}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <IconButton aria-label="add" color="info" onClick={() => handleAddRowColaborador(values, colaborador, setFieldValue)} >
                                                                                    <AiOutlinePlusCircle />
                                                                                </IconButton>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                    {busquedaUsuario.length == 0 ?
                                                                        <TableRow key={'colProy-o'}>
                                                                            <TableCell></TableCell>
                                                                            <TableCell></TableCell>
                                                                            <TableCell>Sin resultados</TableCell>
                                                                            <TableCell></TableCell>
                                                                            <TableCell></TableCell>
                                                                        </TableRow> : <></>
                                                                    }
                                                                </TableBody>
                                                            </Table>
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </TabPane>
                                        </TabContent>
                                    </ModalBody>
                                </ModalStrap>
                                <ModalStrap isOpen={proyModal} toggle={toggleProy} className="custom-modal">
                                    <ModalHeader toggle={toggleProy}>
                                        <Typography id="modal-modal-title" >Proyectos</Typography>
                                    </ModalHeader>
                                    <ModalBody>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>#</TableCell>
                                                    <TableCell>Titulo</TableCell>
                                                    <TableCell>Acción</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {misProyectos.filter(x => x.codigo !== values.idproyecto).map((proy, index) => (
                                                    <TableRow key={'colProy-' + proy.codigo}>
                                                        <TableCell style={{ width: '5%' }}>{index + 1}</TableCell>
                                                        <TableCell>
                                                            {proy.descripcion}
                                                        </TableCell>
                                                        <TableCell>
                                                            {isProyectSelected(values, proy) ? <></>
                                                                :
                                                                <IconButton aria-label="out" color="info" onClick={() => handleAddProyectoRel(values, proy, setFieldValue)} >
                                                                    <AiOutlinePlusCircle />
                                                                </IconButton>
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </ModalBody>
                                </ModalStrap>
                            </Form>
                        )}
                    </Formik>
                </CardBody>
            </Card>
        </div>
    );
    //#endregion
}
